import { Input, message, Switch } from "antd";
import moment from "jalali-moment";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import api from "../../../api/api";
import AppUsageTracker from "../../../Components/AppUsageTracker/AppUsageTracker";
import EpollAnswers from "../../../Components/Epoll/EpollAnswers";
import Loading from "../../../Components/Loading/Loading";
import RoadmapControls from "../../../Components/RoadmapControls/RoadmapControls";
import {
  defaultPsychologyRoadmapNote,
  defaultRenewalRoadmapNote,
  defaultRoadmapNote,
} from "../../../constants/defaultRoadmapNote";
import { buildAutoNote, normalizeUserNote } from "../../../Util/autoNoteBuilder";
import * as actions from "../../../store/actions/action";
import {
  defaultSkillsTermsValue,
  defaultTermsValue,
  noteDefaultValue,
} from "../../../Util/defaultValues";
import EpollParser, { getPlainLabel } from "../../../Util/EpollParser";
import getUnusedFlags from "../../../Util/getUnusedFlags";
import ActionsRoadmap from "./ActionsRoadmap/ActionsRoadmap";
import SkillsRoadmap from "./SkillsRoadmap/SkillsRoadmap";
import styles from "./UserRoadmap.module.css";
// import autoAdjectives from "../../../constants/autoAdjectives";
import WarningIcon from "@mui/icons-material/Warning";
import autoTypes from "../../../constants/autoTypes";
import { flagsConflict } from "../../../constants/flagsConflict";

export const isAllFlagsAddedToTerms = (targetFlagsArr = [], terms = []) => {
  return targetFlagsArr.every((id) =>
    terms.find((term) => term.find((flag) => flag.id === id)),
  );
};

export const findTermAndIndexOfPreOfFlag = (targetFlag = {}, terms = []) => {
  const cond = [];

  const preOfTarget = targetFlag.preConditionFlags;

  for (const target of preOfTarget) {
    // loop into terms
    for (let termIndex = 0; termIndex < terms.length; termIndex++) {
      const term = terms[termIndex];
      // loop into flags
      for (let flagIndex = 0; flagIndex < term.length; flagIndex++) {
        const flag = term[flagIndex];
        if (flag.id === target.id) {
          cond.push({
            termIndex,
            flagIndex,
          });
        }
      }
    }
  }

  return cond;
};

export const findTermAndIndexOfPreOfFlagBaseOnMainFlag = (
  targetFlag = {},
  terms = [],
) => {
  const cond = [];

  // loop into terms
  for (let termIndex = 0; termIndex < terms.length; termIndex++) {
    const term = terms[termIndex];
    // loop into flags
    for (let flagIndex = 0; flagIndex < term.length; flagIndex++) {
      const flag = term[flagIndex];
      const a = flag.preConditionFlags.find((i) => i.id === targetFlag.id);
      if (a) cond.push({ termIndex, flagIndex });
    }
  }

  return cond;
};

export const findTermAndIndexOfPreOfHiddenFlagBaseOnMainFlag = (
  targetFlag = {},
  terms = [],
  allFlags = [],
) => {
  return terms
    .map((term, termIndex) =>
      term
        .map((flag, flagIndex) => {
          const c = findFlagRef(flag, allFlags)?.preConditionFlags?.find(
            (i) => i.id === targetFlag.id,
          );
          if (c) return { termIndex, flagIndex };
        })
        .filter((e) => e),
    )
    .flat();
};

export const findFlagPositionFromArrayTerms = (targetFlagId, terms = []) => {
  for (const term of terms) {
    for (const flag of term) {
      if (flag.id === targetFlagId) {
        return {
          termIndex: terms.indexOf(term),
          flagIndex: term.indexOf(flag),
        };
      }
    }
  }

  return null;
};

export const findFlagPositionFromObjectTerms = (targetFlagId, terms = []) => {
  for (const termIndex of [1, 2, 3, 4]) {
    let flagIndex = 0;
    for (const flag of terms[`term${termIndex}`].flags) {
      if (flag.id === targetFlagId) {
        return { termIndex, flagIndex };
      }
      flagIndex += 1;
    }
  }

  return null;
};

export const insertFlagIntoTerm = ({ flag, termIndex, colIndex, terms }) => {
  const clone = [...terms];
  if (clone[termIndex]) {
    const finalColIndex = Math.min(colIndex, clone[termIndex].length);
    clone[termIndex].splice(finalColIndex + 1, 0, flag);
  }
  return clone;
};

export const isOneOfFlagsAddedToTerms = (targetFlagsArr = [], terms = []) => {
  for (const uniqueId of targetFlagsArr) {
    const exists = terms.find((term) => term.find((fl) => fl.id === +uniqueId));
    if (exists) return true;
  }
  return false;
};

export const findTermAndIndexOfPostOfFlag = (targetFlag = {}, terms = []) => {
  const allFl = [...terms[0], ...terms[1], ...terms[2], ...terms[3]];
  const cc = allFl.filter((fl) =>
    fl?.preConditionFlags?.find((el) => el.id === targetFlag.id),
  );
  const postOfTarget = [...targetFlag.postConditionFlags, ...cc];

  const cond = [];

  for (const target of postOfTarget) {
    // loop into terms
    for (let termIndex = 0; termIndex < terms.length; termIndex++) {
      const term = terms[termIndex];
      // loop into flags
      for (let flagIndex = 0; flagIndex < term.length; flagIndex++) {
        const flag = term[flagIndex];
        if (flag.id === target.id) {
          cond.push({
            termIndex,
            flagIndex,
          });
        }
      }
    }
  }

  return cond;
};

const UserRoadmapBeta = ({ ClearLoading, operatorData }) => {
  const params = useParams();
  const isValidUUID =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(
      params.id,
    );
  const LIMIT_FLAGS_COUNT = 40;

  // states
  const [flags, setFlags] = useState([]);
  const [otherRoadmapsFlagIds, setOtherRoadmapsFlagIds] = useState([]);
  const [roadmapStatus, setRoadmapStatus] = useState("UN_COMPLETED");
  const [autoPublish, setAutoPublish] = useState(false);
  const [generatorUsed, setGeneratorUsed] = useState(false);
  const [flagsClone, setFlagsClone] = useState([]);
  const [deletedFlags, setDeletedFlags] = useState([]);
  const [deletedHiddenFlags, setDeletedHiddenFlags] = useState([]);
  const [flagsPosBeforeDelete, setFlagsPosBeforeDelete] = useState([]);
  const [autoAdjectives, setAutoAdjectives] = useState([]);
  const [ignoreImportanceArr, setIgnoreImportanceArr] = useState([]);
  const [skills, setSkills] = useState();
  const [prevNoteForUser, setPrevNoteForUser] = useState();
  const [prevRoadmapKey, setPrevRoadmapKey] = useState();
  const [prevRoadmapFlagIds, setPrevRoadmapFlagIds] = useState([]);
  const [typeData, setTypeData] = useState({ age: 0, gender: "" });
  const [terms, setTerms] = useState(defaultTermsValue);
  const [skillTerms, setSkillTerms] = useState(defaultSkillsTermsValue);
  const [epollId, setEpollId] = useState();
  const [questionAnswers, setQuestionAnswers] = useState([]);
  const [answers, setAnswers] = useState();
  const [formDto, setFormDto] = useState();
  const [userData, setUserData] = useState();
  const [isFetchedData, setIsFetchedData] = useState(false);
  const [isPublished, setIsPublished] = useState();
  const [key, setKey] = useState(null);
  const [starQuestions, setStarQuestions] = useState([]);
  const [answersNote, setAnswersNote] = useState({});
  const [answersHighlight, setAnswersHighlight] = useState(null);
  const [answersChecked, setAnswersChecked] = useState(null);
  const [roadmapId, setRoadmapId] = useState(null);
  const [note, setNote] = useState(null);
  const [userNote, setUserNote] = useState(null);
  const [userNoteVoiceUrl, setUserNoteVoiceUrl] = useState(null);
  const [questionToFlags, setQuestionToFlags] = useState(null);
  const [questionToTypes, setQuestionToTypes] = useState(null);
  const [globalSearch, setGlobalSearch] = useState("");
  const [isRoadmapChanged, setIsRoadmapChanged] = useState(false);
  const [editigMode, setEditingMode] = useState("actions");
  const [search, setSearch] = useState("");
  const [productCode, setProductCode] = useState();
  const [updateForcer, setUpdateForcer] = useState(0);
  const [username, setUsername] = useState("");
  const [selectedType, setSelectedType] = useState(null);
  const [tempFlagsPos, setTempFlagsPos] = useState([]);
  const [formId, setFormId] = useState(0);
  const [ignoreTag, setIgnoreTags] = useState([]);
  const [ignoreFlags, setIgnoreFlags] = useState([]);
  const [flagsHistory, setFlagsHistory] = useState({});
  const [prevTermsClone, setPrevTermsClone] = useState();
  const [autoNote, setAutoNote] = useState([]);
  const [transparentMode, setTransparentMode] = useState(false);
  const [epollRecordId, setEpollRecordId] = useState();
  const [RoadmapHasNoteFromBefore, setRoadmapHasNoteFromBefore] =
    useState(false);
  const [monitorSession, setMonitorSession] = useState();
  const [segment, setSegment] = useState("all");
  const [questionLabelToScroll, setQuestionLabelToScroll] = useState(null);

  const allRoadmapFlags = useMemo(
    () =>
      Object.keys(terms)
        .map((key) => terms[key]?.flags ?? [])
        .flat()
        .map((e) => e?.id)
        .filter((e) => e),
    [terms, flags],
  );

  const getFlagImportance = (flag) => {
    // if (flag?.bookmarkQuestionId) {
    //   const obj = tempFlagsPos.find((e) => e.id == flag.bookmarkQuestionId);
    //   return obj?.importance ?? 0;
    // }

    const importanceArr = (flag?.autoGenerated?.relatedQuestions ?? [])
      .map((el) => {
        const obj = tempFlagsPos.find(
          (p) =>
            p.id == el.id &&
            p.answer_id == el.answer_id &&
            flag.id === p.flagId,
        );

        return obj?.importance;
      })
      .filter((e) => typeof e === "number");

    if (importanceArr.length > 0) {
      return Math.min(...importanceArr);
    }

    return 0;
  };

  const importantAreas = useMemo(() => {
    const fullFlagsArr = Object.keys(terms)
      .map((tk) => terms[tk].flags)
      .flat()
      .filter((e) => !e.hidden)
      .map((fl) => ({ ...fl, importance: getFlagImportance(fl) }));

    const areas = {};
    // init areas
    Array.from(new Set(fullFlagsArr.map((fl) => fl.type))).map(
      (area) => (areas[area] = []),
    );

    fullFlagsArr.forEach((fl) => areas[fl.type].push(fl.importance));

    const K = 3;
    return Object.keys(areas)
      .map((area) => {
        const zeroCount = areas[area].filter((e) => e === 0).length;
        const totalCount = areas[area].length;
        const zeroCountRate = (zeroCount / totalCount) * K;
        const sumScore = areas[area]
          .map((rt) => 3 - rt)
          .reduce((accumulator, currentValue) => accumulator + currentValue, 0);

        return {
          area,
          zeroCount,
          totalCount,
          sumScore,
          zeroCountRate,
          score: sumScore / totalCount + zeroCountRate,
        };
      })
      .filter((e) => e.area !== "action")
      .sort((a, b) => b.score - a.score)
      .filter((el, i, arrClone) => {
        if (i === 0 || i === 1) return true;

        if (i === 2) {
          const avg =
            arrClone
              .map((obj) => obj.score)
              .reduce(
                (accumulator, currentValue) => accumulator + currentValue,
                0,
              ) / arrClone.length;

          return el.score >= avg;
        }

        return false;
      });
  }, [terms, getFlagImportance, tempFlagsPos]);

  const getImportantAreasFn = useCallback(
    (tempCloneTerms) => {
      const fullFlagsArr = Object.keys(tempCloneTerms)
        .map((tk) => tempCloneTerms[tk].flags)
        .flat()
        .filter((e) => !e.hidden)
        .map((fl) => ({ ...fl, importance: getFlagImportance(fl) }));

      const areas = {};
      // init areas
      Array.from(new Set(fullFlagsArr.map((fl) => fl.type))).map(
        (area) => (areas[area] = []),
      );

      fullFlagsArr.forEach((fl) => areas[fl.type].push(fl.importance));

      const K = 3;
      return Object.keys(areas)
        .map((area) => {
          const zeroCount = areas[area].filter((e) => e === 0).length;
          const totalCount = areas[area].length;
          const zeroCountRate = (zeroCount / totalCount) * K;
          const sumScore = areas[area]
            .map((rt) => 3 - rt)
            .reduce(
              (accumulator, currentValue) => accumulator + currentValue,
              0,
            );

          return {
            area,
            zeroCount,
            totalCount,
            sumScore,
            zeroCountRate,
            score: sumScore / totalCount + zeroCountRate,
          };
        })
        .filter((e) => e.area !== "action")
        .sort((a, b) => b.score - a.score)
        .filter((el, i, arrClone) => {
          if (i === 0 || i === 1) return true;

          if (i === 2) {
            const avg =
              arrClone
                .map((obj) => obj.score)
                .reduce(
                  (accumulator, currentValue) => accumulator + currentValue,
                  0,
                ) / arrClone.length;

            return el.score >= avg;
          }

          return false;
        });
    },
    [getFlagImportance, tempFlagsPos],
  );

  const loadAdjectives = () => {
    api
      .get(`/question-adjective/all`)
      .then((res) => {
        setMonitorSession(res.data.session);
        setAutoAdjectives(
          res.data.map((e) => ({
            questionId: e.questionId,
            answerId: e.answerId,
            valueToInsert: e.adjective,
          })),
        );
      })
      .catch(() => message.error("خطا در لود صفات"));
  };

  const overLoadFLags = useMemo(() => {
    let allFlags = [
      ...terms.term1.flags.map((fl) => ({ ...fl, termIndex: 1 })),
      ...terms.term2.flags.map((fl) => ({ ...fl, termIndex: 2 })),
      ...terms.term3.flags.map((fl) => ({ ...fl, termIndex: 3 })),
      ...terms.term4.flags.map((fl) => ({ ...fl, termIndex: 4 })),
    ];
    const allNonHiddenFlags = allFlags.filter((c) => !c.hidden);

    const deletedFlagsId = [];
    for (const round of [3, 2, 1, 0]) {
      if (allNonHiddenFlags.length - deletedFlagsId.length <= LIMIT_FLAGS_COUNT)
        break;

      const tempIds = allFlags
        .filter((fl) => !fl.hidden && getFlagImportance(fl) === round)
        .slice(
          -(
            allNonHiddenFlags.length -
            LIMIT_FLAGS_COUNT -
            deletedFlagsId.length
          ),
        )
        .map((e) => e.id);

      deletedFlagsId.push(...tempIds);
    }

    return deletedFlagsId;
  }, [terms, tempFlagsPos]);

  const [showImportantOnly, setShowImportantOnly] = useState(false);

  // refs
  const flagsRef = useRef();
  const skillsRef = useRef();

  const sessionSubmitter = useCallback(
    () =>
      api
        .post("/operators-monitoring", {
          epollId: epollRecordId ?? params.id,
          session: monitorSession,
          generatorUsed,
        })
        .then((res) => {
          setMonitorSession(res.data.session);
        })
        .catch(() => message.error("خطا در ثبت سشن")),
    [epollRecordId, params.id, monitorSession, generatorUsed],
  );

  useEffect(() => {
    getAutoNotes();
  }, []);

  useEffect(() => {
    loadAdjectives();
  }, [formId]);

  useEffect(() => {
    const interval = setInterval(() => {
      sessionSubmitter();
    }, 10_000);

    return () => clearInterval(interval);
  }, [sessionSubmitter]);

  const limitFlagsCount_OLD = (terms, sendMessage = false, importance = 0) => {
    const termsClone = { ...terms };
    let allFlags = [
      ...termsClone.term1.flags.map((fl) => ({ ...fl, termIndex: 1 })),
      ...termsClone.term2.flags.map((fl) => ({ ...fl, termIndex: 2 })),
      ...termsClone.term3.flags.map((fl) => ({ ...fl, termIndex: 3 })),
      ...termsClone.term4.flags.map((fl) => ({ ...fl, termIndex: 4 })),
    ];
    let deletedFlags = [];

    let remainToCut =
      allFlags.filter((c) => !c.hidden).length - LIMIT_FLAGS_COUNT;

    // do not need to cut
    if (remainToCut <= 0) {
      if (sendMessage) {
        message.warning("اندازه نقشه راه کمتر از ۴۰ کارت است");
      }
      return { termsClone, deletedFlags };
    }

    const firstDeletedFlags = allFlags
      .filter((c) => !c.hidden)
      .slice(-remainToCut)
      .at(0);

    const indexOfFirstDeletedFlag = allFlags.findIndex(
      ({ id }) => id === firstDeletedFlags.id,
    );

    const ii = allFlags.length - indexOfFirstDeletedFlag;
    deletedFlags = allFlags.slice(-ii);
    allFlags = allFlags.slice(0, -ii);

    for (let index = 1; index <= 4; index++) {
      termsClone[`term${index}`].flags = allFlags
        .filter((fl) => fl.termIndex === index)
        .map(({ termIndex, ...fl }) => fl);
    }

    return { termsClone, deletedFlags };
  };

  const toggleImportance = (id) => {
    if (ignoreImportanceArr.includes(id)) {
      setIgnoreImportanceArr((prev) => prev.filter((e) => e !== id));
    } else {
      setIgnoreImportanceArr((p) => [...p, id]);
    }
  };

  const limitFlagsCount = (terms, sendMessage = false) => {
    let deletedFlags = [];
    const termsClone = { ...terms };
    let allFlags = [
      ...termsClone.term1.flags.map((fl, i) => ({
        ...fl,
        termIndex: 1,
        rowIndex: i,
      })),
      ...termsClone.term2.flags.map((fl, i) => ({
        ...fl,
        termIndex: 2,
        rowIndex: i,
      })),
      ...termsClone.term3.flags.map((fl, i) => ({
        ...fl,
        termIndex: 3,
        rowIndex: i,
      })),
      ...termsClone.term4.flags.map((fl, i) => ({
        ...fl,
        termIndex: 4,
        rowIndex: i,
      })),
    ];

    const nonHiddenFlags = allFlags.filter((e) => !e.hidden);
    const remainToCut = nonHiddenFlags.length - LIMIT_FLAGS_COUNT;

    // do not need to cut
    if (remainToCut <= 0) {
      if (sendMessage) {
        message.warning("اندازه نقشه راه کمتر از ۴۰ کارت است");
      }
      return { termsClone, deletedFlags };
    }

    for (const round of [3, 2, 1, 0]) {
      if (nonHiddenFlags.length - deletedFlags.length <= LIMIT_FLAGS_COUNT) {
        break;
      }

      const tempIds = allFlags
        .filter((fl) => !fl.hidden && getFlagImportance(fl) === round)
        .slice(
          -(nonHiddenFlags.length - LIMIT_FLAGS_COUNT - deletedFlags.length),
        );
      console.log({ round, tempIds });
      deletedFlags.push(...tempIds);
    }

    deletedFlags = deletedFlags.filter(
      (e) => !ignoreImportanceArr.includes(e.id),
    );

    for (let index = 1; index <= 4; index++) {
      termsClone[`term${index}`].flags = termsClone[
        `term${index}`
      ].flags.filter((fl) => !deletedFlags.find((el) => el.id === fl.id));
    }

    console.log({ deletedFlags, termsClone });

    return { termsClone, deletedFlags };
  };

  const getDeleteFlags = (terms) => {
    const termsClone = { ...terms };
    let allFlags = [
      ...termsClone.term1.flags.map((fl) => ({ ...fl, termIndex: 1 })),
      ...termsClone.term2.flags.map((fl) => ({ ...fl, termIndex: 2 })),
      ...termsClone.term3.flags.map((fl) => ({ ...fl, termIndex: 3 })),
      ...termsClone.term4.flags.map((fl) => ({ ...fl, termIndex: 4 })),
    ];
    let deletedFlags = [];

    let remainToCut =
      allFlags.filter((c) => !c.hidden).length - LIMIT_FLAGS_COUNT;

    // do not need to cut
    if (remainToCut <= 0) return deletedFlags;

    const firstDeletedFlags = allFlags
      .filter((c) => !c.hidden)
      .slice(-remainToCut)
      .at(0);

    const indexOfFirstDeletedFlag = allFlags.findIndex(
      ({ id }) => id === firstDeletedFlags.id,
    );

    const ii = allFlags.length - indexOfFirstDeletedFlag;
    deletedFlags = allFlags.slice(-ii);

    return deletedFlags;
  };

  const getFlagsPositionExporter = (terms) => {
    return [
      ...terms.term1.flags.map((fl, i) => ({
        id: fl.id,
        termIndex: 1,
        rowIndex: i,
      })),
      ...terms.term2.flags.map((fl, i) => ({
        id: fl.id,
        termIndex: 2,
        rowIndex: i,
      })),
      ...terms.term3.flags.map((fl, i) => ({
        id: fl.id,
        termIndex: 3,
        rowIndex: i,
      })),
      ...terms.term4.flags.map((fl, i) => ({
        id: fl.id,
        termIndex: 4,
        rowIndex: i,
      })),
    ];
  };

  const revertToBeforeDelete = (tempTerms) => {
    if (flagsPosBeforeDelete.length === 0) {
      message.error("خطا در بازگردانی نقشه راه");

      return {
        ...tempTerms,
        term4: {
          ...tempTerms.term4,
          flags: [
            ...tempTerms.term4.flags,
            ...deletedFlags,
            ...deletedHiddenFlags,
          ],
        },
      };
    }

    const allFlags = [
      ...tempTerms.term1.flags,
      ...tempTerms.term2.flags,
      ...tempTerms.term3.flags,
      ...tempTerms.term4.flags,
      ...deletedFlags,
      ...deletedHiddenFlags,
    ];

    return {
      term1: {
        ...tempTerms.term1,
        flags: flagsPosBeforeDelete
          .filter((el) => el.termIndex === 1)
          .sort((a, b) => a.rowIndex - b.rowIndex)
          .map((fl) => allFlags.find((e) => e.id === fl.id))
          .filter((e) => e),
      },
      term2: {
        ...tempTerms.term2,
        flags: flagsPosBeforeDelete
          .filter((el) => el.termIndex === 2)
          .sort((a, b) => a.rowIndex - b.rowIndex)
          .map((fl) => allFlags.find((e) => e.id === fl.id))
          .filter((e) => e),
      },
      term3: {
        ...tempTerms.term3,
        flags: flagsPosBeforeDelete
          .filter((el) => el.termIndex === 3)
          .sort((a, b) => a.rowIndex - b.rowIndex)
          .map((fl) => allFlags.find((e) => e.id === fl.id))
          .filter((e) => e),
      },
      term4: {
        ...tempTerms.term4,
        flags: flagsPosBeforeDelete
          .filter((el) => el.termIndex === 4)
          .sort((a, b) => a.rowIndex - b.rowIndex)
          .map((fl) => allFlags.find((e) => e.id === fl.id))
          .filter((e) => e),
      },
    };
  };

  // const rePositionHiddenFlags = (flags = [], updateTerms = true) => {
  //   const tempTerms = { ...terms };
  //   console.log("reach", { flags, terms, tempTerms });
  //   const allFlags = allRoadmapFlags.map((e) =>
  //     findFlagRef({ id: e }, flagsClone)
  //   );

  //   for (const fl of flags) {
  //     const placement = { termIndex: 1, flagIndex: 0 };

  //     const pre1Ids = allFlags
  //       .filter((el) => el.postConditionFlags.find((pl) => pl.id === fl.id))
  //       .map((e) => e.id);

  //     const shouldRenderBeforeIds = [
  //       ...pre1Ids,
  //       ...fl.preConditionFlags.map((e) => e.id),
  //     ].filter((e) => allRoadmapFlags.includes(e));

  //     const conditions = shouldRenderBeforeIds.map((id) =>
  //       findFlagPositionFromObjectTerms(id, tempTerms)
  //     );

  //     if (conditions.length > 0) {
  //       const termIndex = Math.max(...conditions.map((val) => val.termIndex));
  //       const flagIndex = Math.max(
  //         ...conditions
  //           .filter((e) => e.termIndex === termIndex)
  //           .map((val) => val.flagIndex)
  //       );

  //       placement.termIndex = termIndex;
  //       placement.flagIndex = flagIndex;
  //     }

  //     const comb = [
  //       ...tempTerms[`term${placement.termIndex}`].flags
  //         .filter((e) => e.id !== fl.id)
  //         .slice(0, placement.flagIndex),
  //       fl,
  //       ...tempTerms[`term${placement.termIndex}`].flags
  //         .filter((e) => e.id !== fl.id)
  //         .slice(placement.flagIndex, -1),
  //     ];

  //     // insert flag into terms
  //     tempTerms[`term${placement.termIndex}`].flags = comb;
  //   }
  //   console.log("second", { tempTerms });
  //   setTerms(tempTerms);
  //   // if (updateTerms) {
  //   //   setTerms(tempTerms);
  //   // }
  //   return tempTerms;
  // };

  const rePositionPrevHiddenFlags = (
    flagId,
    tempoTerms,
    updateTerms = true,
  ) => {
    console.log("---------");
    console.log({ tempoTerms, flagId });
    const prevFlag = findPreviousFlag(flagId, flagsClone);
    if (!prevFlag?.hidden) return tempoTerms;

    let tempTerms = {
      term1: {
        ...tempoTerms.term1,
        flags: tempoTerms.term1.flags.filter(
          (e) => ![prevFlag.id, flagId].includes(e.id),
        ),
      },
      term2: {
        ...tempoTerms.term2,
        flags: tempoTerms.term2.flags.filter(
          (e) => ![prevFlag.id, flagId].includes(e.id),
        ),
      },
      term3: {
        ...tempoTerms.term3,
        flags: tempoTerms.term3.flags.filter(
          (e) => ![prevFlag.id, flagId].includes(e.id),
        ),
      },
      term4: {
        ...tempoTerms.term4,
        flags: tempoTerms.term4.flags.filter(
          (e) => ![prevFlag.id, flagId].includes(e.id),
        ),
      },
    };

    const allFlags = allRoadmapFlags.map((e) =>
      findFlagRef({ id: e }, flagsClone),
    );

    console.log("reach", { flags, tempTerms });

    const placement = { termIndex: 1, flagIndex: 0 };

    const pre1Ids = allFlags
      .filter((el) => el.preConditionFlags.find((pl) => pl.id === prevFlag.id))
      .map((e) => e.id);

    const shouldRenderBeforeIds = [
      ...pre1Ids,
      ...prevFlag.postConditionFlags.map((e) => e.id),
    ].filter((e) => allRoadmapFlags.includes(e));

    const conditions = shouldRenderBeforeIds
      .map((id) => findFlagPositionFromObjectTerms(id, tempTerms))
      .filter((e) => e);
    console.log({ conditions });

    if (conditions.length > 0) {
      const termIndex = Math.min(...conditions.map((val) => val.termIndex));
      const flagIndex = Math.min(
        ...conditions
          .filter((e) => e.termIndex === termIndex)
          .map((val) => val.flagIndex),
      );

      placement.termIndex = termIndex;
      placement.flagIndex = flagIndex;
    } else {
      return tempTerms;
    }

    console.warn("reach herer", { tempTerms });
    // insert flag into terms
    tempTerms[`term${placement.termIndex}`].flags = [
      ...tempTerms[`term${placement.termIndex}`].flags
        .filter((e) => e.id !== prevFlag.id)
        .slice(0, placement.flagIndex),
      prevFlag,
      ...tempTerms[`term${placement.termIndex}`].flags
        .filter((e) => e.id !== prevFlag.id)
        .slice(placement.flagIndex),
    ];

    console.log("second", { tempTerms });

    if (updateTerms) {
      setTerms(tempTerms);
    }
    return tempTerms;
  };

  useEffect(() => {
    if (!prevRoadmapKey) {
      setPrevRoadmapFlagIds([]);
      return;
    }
    api
      .get("/roadmaps/find-by-key-admin/" + prevRoadmapKey)
      .then((res) => {
        const prevTerms = res?.data?.data?.roadmap?.terms ?? [];
        const ids = prevTerms.flatMap((term) =>
          (term.flags ?? []).map((flag) => flag.id),
        );
        setPrevRoadmapFlagIds(Array.from(new Set(ids)));
      })
      .catch(() => setPrevRoadmapFlagIds([]));
  }, [prevRoadmapKey]);

  const removeDuplicateImportantFlags = () => {
    const prevSet = new Set((prevRoadmapFlagIds ?? []).map((e) => +e));
    const arr = [];
    Object.keys(terms).forEach((tk) => {
      (terms[tk]?.flags ?? []).forEach((fl) => {
        if (prevSet.has(+fl.id) && [2, 3].includes(getFlagImportance(fl))) {
          arr.push(fl.id);
        }
      });
    });

    if (arr.length === 0) {
      message.info("کارت تکراری با اهمیت ۲ یا ۳ پیدا نشد");
      return;
    }

    setTerms((prevTerms) => {
      let r = {
        term1: {
          ...prevTerms.term1,
          flags: prevTerms.term1.flags.filter((e) => !arr.includes(e.id)),
        },
        term2: {
          ...prevTerms.term2,
          flags: prevTerms.term2.flags.filter((e) => !arr.includes(e.id)),
        },
        term3: {
          ...prevTerms.term3,
          flags: prevTerms.term3.flags.filter((e) => !arr.includes(e.id)),
        },
        term4: {
          ...prevTerms.term4,
          flags: prevTerms.term4.flags.filter((e) => !arr.includes(e.id)),
        },
      };
      for (const a of arr) {
        r = rePositionPrevHiddenFlags(a, r, false);
      }
      return r;
    });

    setFlags((prev) =>
      [
        ...Array.from(new Set(arr))
          .map((id) => findFlagRef({ id }, flagsRef.current))
          .filter((e) => e),
        ...prev,
      ].filter((e) => e),
    );

    setIsRoadmapChanged(true);
    message.success(`${arr.length} کارت تکراری حذف شد`);
  };

  const rePositionAllHiddenFlags = (tempoTerms, updateTerms = true) => {
    console.log("--------- All ---------");

    const allTermFlags = [
      ...tempoTerms.term1.flags,
      ...tempoTerms.term2.flags,
      ...tempoTerms.term3.flags,
      ...tempoTerms.term4.flags,
    ];
    const allHiddenFlags = allTermFlags.filter((e) => e.hidden);

    const allHiddenFlagsId = allHiddenFlags.map((e) => e.id);
    const allFlags = allTermFlags.map((e) => findFlagRef(e, flagsClone));
    console.log({ allHiddenFlags });
    // let tempTerms = {
    //   term1: {
    //     ...tempoTerms.term1,
    //     flags: tempoTerms.term1.flags.filter(
    //       (e) => !allHiddenFlagsId.includes(e.id)
    //     ),
    //   },
    //   term2: {
    //     ...tempoTerms.term2,
    //     flags: tempoTerms.term2.flags.filter(
    //       (e) => !allHiddenFlagsId.includes(e.id)
    //     ),
    //   },
    //   term3: {
    //     ...tempoTerms.term3,
    //     flags: tempoTerms.term3.flags.filter(
    //       (e) => !allHiddenFlagsId.includes(e.id)
    //     ),
    //   },
    //   term4: {
    //     ...tempoTerms.term4,
    //     flags: tempoTerms.term4.flags.filter(
    //       (e) => !allHiddenFlagsId.includes(e.id)
    //     ),
    //   },
    // };
    let tempTerms = { ...tempoTerms };

    for (const hiddenFl of allHiddenFlags) {
      const placement = { termIndex: 1, flagIndex: 0 };
      const flagRef = findFlagRef(hiddenFl, flagsClone);

      const pre1Ids = allFlags
        .filter((el) =>
          el.preConditionFlags.find((pl) => pl.id === hiddenFl.id),
        )
        .map((e) => e.id);

      const shouldRenderBeforeIds = [
        ...pre1Ids,
        ...flagRef.postConditionFlags.map((e) => e.id),
      ].filter((e) => allRoadmapFlags.includes(e));

      const conditions = shouldRenderBeforeIds
        .map((id) => findFlagPositionFromObjectTerms(id, tempTerms))
        .filter((e) => e);

      if (conditions.length > 0) {
        const termIndex = Math.min(...conditions.map((val) => val.termIndex));
        const flagIndex = Math.min(
          ...conditions
            .filter((e) => e.termIndex === termIndex)
            .map((val) => val.flagIndex),
        );

        placement.termIndex = termIndex;
        placement.flagIndex = flagIndex;
      } else if (1) {
        const i = findFlagPositionFromObjectTerms(hiddenFl.id, tempTerms);
        placement.termIndex = i.termIndex;
        placement.flagIndex = i.flagIndex;
      } else {
        continue;
      }
      tempTerms = {
        term1: {
          ...tempTerms.term1,
          flags: tempTerms.term1.flags.filter((e) => e.id !== hiddenFl.id),
        },
        term2: {
          ...tempTerms.term2,
          flags: tempTerms.term2.flags.filter((e) => e.id !== hiddenFl.id),
        },
        term3: {
          ...tempTerms.term3,
          flags: tempTerms.term3.flags.filter((e) => e.id !== hiddenFl.id),
        },
        term4: {
          ...tempTerms.term4,
          flags: tempTerms.term4.flags.filter((e) => e.id !== hiddenFl.id),
        },
      };

      // insert flag into terms
      tempTerms[`term${placement.termIndex}`].flags = [
        ...tempTerms[`term${placement.termIndex}`].flags.slice(
          0,
          placement.flagIndex,
        ),
        hiddenFl,
        ...tempTerms[`term${placement.termIndex}`].flags.slice(
          placement.flagIndex,
        ),
      ];
    }

    console.log("second", { tempTerms });

    if (updateTerms) {
      setTerms(tempTerms);
    }
    return tempTerms;
  };

  const findPreviousFlag = (flagId) => {
    const flIndex = allRoadmapFlags.findIndex((id) => id === flagId);
    const prevFlagId = allRoadmapFlags[flIndex - 1];

    if (!prevFlagId) return null;

    const allTermsFlags = [
      ...terms.term1.flags,
      ...terms.term2.flags,
      ...terms.term3.flags,
      ...terms.term4.flags,
    ];
    return allTermsFlags.find((e) => e.id === prevFlagId);
  };

  const resortPrevFlag = (flagId, tempFlags = terms) => {
    const prevFlag = findPreviousFlag(flagId, tempFlags);
    if (!prevFlag?.hidden) return tempFlags;
    return rePositionPrevHiddenFlags([prevFlag], tempFlags);
  };

  const pruneOrphanHiddenFlags = (tempTerms) => {
    const removedHidden = [];
    let working = {
      term1: { ...tempTerms.term1, flags: [...tempTerms.term1.flags] },
      term2: { ...tempTerms.term2, flags: [...tempTerms.term2.flags] },
      term3: { ...tempTerms.term3, flags: [...tempTerms.term3.flags] },
      term4: { ...tempTerms.term4, flags: [...tempTerms.term4.flags] },
    };

    for (let guard = 0; guard < 1000; guard++) {
      const survivorFlags = [
        ...working.term1.flags,
        ...working.term2.flags,
        ...working.term3.flags,
        ...working.term4.flags,
      ];
      const survivorIds = new Set(survivorFlags.map((e) => e.id));
      const survivorRefs = survivorFlags.map((e) => findFlagRef(e, flagsClone));

      const orphanIds = survivorFlags
        .filter((fl) => fl.hidden)
        .filter((hiddenFl) => {
          const flagRef = findFlagRef(hiddenFl, flagsClone);
          const dependentIds = survivorRefs
            .filter((el) =>
              el?.preConditionFlags?.find((pl) => pl.id === hiddenFl.id),
            )
            .map((e) => e.id);
          const anchorIds = [
            ...dependentIds,
            ...(flagRef?.postConditionFlags ?? []).map((e) => e.id),
          ].filter((id) => id !== hiddenFl.id && survivorIds.has(id));
          return anchorIds.length === 0;
        })
        .map((e) => e.id);

      if (orphanIds.length === 0) break;

      for (const id of orphanIds) {
        const removed = survivorFlags.find((e) => e.id === id);
        if (removed) removedHidden.push(removed);
      }

      working = {
        term1: {
          ...working.term1,
          flags: working.term1.flags.filter((e) => !orphanIds.includes(e.id)),
        },
        term2: {
          ...working.term2,
          flags: working.term2.flags.filter((e) => !orphanIds.includes(e.id)),
        },
        term3: {
          ...working.term3,
          flags: working.term3.flags.filter((e) => !orphanIds.includes(e.id)),
        },
        term4: {
          ...working.term4,
          flags: working.term4.flags.filter((e) => !orphanIds.includes(e.id)),
        },
      };
    }

    return { prunedTerms: working, removedHidden };
  };

  const limitRoadmapHandler = () => {
    if (deletedFlags?.length === 0) {
      setFlagsPosBeforeDelete(getFlagsPositionExporter(terms));
      const { termsClone, deletedFlags: tempDeletedFlags } = limitFlagsCount(
        terms,
        true,
      );

      setDeletedFlags(tempDeletedFlags);
      let newTerm = balanceTerms(termsClone);

      const { prunedTerms, removedHidden } = pruneOrphanHiddenFlags(newTerm);
      setDeletedHiddenFlags(removedHidden);

      newTerm = rePositionAllHiddenFlags(prunedTerms, false);

      setFlags(getUnusedFlags(newTerm, flagsClone));
      setTerms(newTerm);
    } else {
      setTerms((prevT) => {
        const response = balanceTerms(revertToBeforeDelete(prevT));
        setFlags(getUnusedFlags(response, flagsClone));
        return response;
      });
      setDeletedFlags([]);
      setDeletedHiddenFlags([]);
      setFlagsPosBeforeDelete([]);
    }
  };

  const loadData = (categories) => {
    api
      .get("/flags", {
        params: {
          page: 1,
          pageSize: 10_000,
          all: true,
          ...(categories ? { filters: { categories } } : {}),
        },
      })
      .then((res) => {
        const data = res.data.data.filter((fl) => fl?.supervisorConfirm);
        setFlags(data);
        setFlagsClone(data);
        flagsRef.current = JSON.parse(JSON.stringify(data));
        ClearLoading();
      })
      .then(() => {
        ClearLoading();
        loadUserTerms();
      })
      .catch(() => {
        ClearLoading();
      });
    api
      .get("skills", { params: { all: 1, page: 1, pageSize: 10_000 } })
      .then((res) => {
        const data = res.data;
        setSkills(data);
        skillsRef.current = JSON.parse(JSON.stringify(data));
      });
  };

  const loadUserTerms = () => {
    setIsFetchedData(false);
    api
      .get(
        (isValidUUID
          ? "/roadmaps/find-by-key-admin/"
          : "/roadmaps/responseid/") + params.id,
      )
      .then((res) => {
        setPrevNoteForUser(res?.data?.prev_roadmap?.noteForUser);
        setStarQuestions(res.data?.starQuestions?.questionIds ?? []);
        setOtherRoadmapsFlagIds(res.data?.otherRoadmapsFlagIds ?? []);
        const data = res.data.data;
        setIsPublished(res.data.publishedAt);
        setPrevRoadmapKey(res?.data?.prev_roadmap?.key);
        setKey(res.data.key);
        setProductCode(res?.data?.productCode);
        setRoadmapStatus(res.data.status ?? "UN_COMPLETED");
        setAutoPublish(res.data.auto_publish ?? false);
        setRoadmapHasNoteFromBefore(res.data.noteForUser ? true : false);
        setAnswersNote(res.data.answersNote ?? {});
        setRoadmapId(res.data.id);
        setFlagsHistory(data?.roadmap?.flagsHistory ?? {});
        setUsername(res.data?.userFirstName?.trim() ?? "پلنیومی");
        setSelectedType(res.data.roadmap_type && res.data.roadmap_type.id);
        if (
          res.data.privateNotes &&
          removeHtmlTags(res.data.privateNotes).trim() !== ""
        ) {
          setNote(res.data.privateNotes);
        } else {
          setNote(noteDefaultValue);
        }

        setUserNoteVoiceUrl(res?.data?.noteForUserVoiceUrl ?? null);
        if (res.data.noteForUser) {
          setUserNote(normalizeUserNote(res.data.noteForUser));
        } else {
          const isRenewal = !!res.data?.prev_roadmap;
          switch (res?.data?.productCode) {
            case "roadmap":
            case "roadmap-1":
            case "roadmap-2":
            case "roadmap-3": {
              const defaultNote = normalizeUserNote(
                (isRenewal ? defaultRenewalRoadmapNote : defaultRoadmapNote)
                  ?.replace(
                    "%name%",
                    res.data?.userFirstName?.trim() ?? "پلنیومی",
                  )
                  ?.trim(),
              );
              setUserNote((prev) => (prev ? prev : defaultNote));
              break;
            }
            case "roadmap-psychology": {
              const defaultNote = normalizeUserNote(
                defaultPsychologyRoadmapNote?.replace(
                  "%name%",
                  res.data?.userFirstName?.trim() ?? "پلنیومی",
                )
                  ?.trim(),
              );
              setUserNote((prev) => (prev ? prev : defaultNote));
              break;
            }
            default:
              console.log("product note not found!");
              break;
          }
        }

        setAnswersHighlight(res.data.highlights);
        setAnswersChecked(res.data.setFlagsOfQuestion);

        setDeletedFlags(data?.roadmap?.deletedFlags ?? []);

        setFlagsPosBeforeDelete(data?.roadmap?.flagsPosBeforeDelete ?? []);

        const cc = ([...data?.roadmap?.terms] ?? []).map((el) =>
          el.flags.map((f) => f.id),
        );

        setPrevTermsClone([].concat(...cc));

        if (data.roadmap.terms) {
          if (Array.isArray(data.roadmap.terms)) {
            const roadmap = {};
            data.roadmap.terms.forEach((term) => {
              roadmap[term.id] = term;
            });

            setTerms(roadmap);
          } else {
            setTerms(data.roadmap.terms);
          }
        }
        if (res.data.skillroadmap.terms) {
          if (Array.isArray(res.data.skillroadmap.terms)) {
            const roadmap = {};
            res.data.skillroadmap.terms.forEach((term) => {
              roadmap[term.id] = term;
            });
            setSkillTerms(roadmap);
          } else {
            message.error("ساختار نقشه راه مهارت با مشکل همراه است.");
          }
        }
        setIsFetchedData(true);
        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
      });
  };

  const loadUserEpoll = () => {
    api
      .get("/epollresponses/roadmap/" + params.id)
      .then((res) => {
        const resData = res.data.data;
        loadData(res?.data?.flagsTag ?? resData?.flagsTag);
        const id = resData.attributes.epollId;
        const epollRecordId = resData.attributes.id;
        const data = resData.attributes.data;
        const formDto = resData.attributes.formdto;
        const user = resData.user;
        const questionToFlags = resData.questionToFlags;
        const questionToTypes = resData.hasQuestionTypes;
        console.warn({ formDto });
        setFormId(formDto.form_id);
        setEpollRecordId(epollRecordId);
        loadFlagPlacements(formDto.form_id);
        getIgnoreFlagsList(formDto.form_id);
        setEpollId(id);
        setAnswers(data);
        setFormDto(formDto);
        setQuestionToFlags(questionToFlags);
        setQuestionToTypes(questionToTypes);
        setUserData({
          first_name: user.firstname,
          last_name: user.lastname,
          mobile: user.mobile,
        });

        ClearLoading();
      })
      .catch(() => {
        ClearLoading();
      });
  };

  const loadUserFromPanel = () => {
    // get questions
    api
      .get("/forms/generator-bundle/" + params.id)
      .then((res) => {
        loadData(res.data.flagsTag);
        loadFlagPlacements(res.data.form.id);
        setAnswers([]);

        const all = [];
        res.data.formQuestions.forEach((qa) => {
          if (qa.field_type === "break") {
            all.push({
              answer: "-",
              answer_id: null,
              field_type: qa.field_type,
              id: qa.id,
              label: getPlainLabel(qa.label),
            });
            return;
          }

          if (qa.field_type === "multitext") {
            qa.options.forEach((el) => {
              // answer
              const answer = res.data.answerQuestions.find(
                (ans) => ans?.question_option?.id === el.id,
              );

              all.push({
                answer: answer?.value ?? answer?.question_option?.label,
                answer_id: answer?.question_option
                  ? answer?.question_option?.id
                  : null,
                field_type: qa.field_type,
                id: qa.id,
                question: `${getPlainLabel(qa.label)}=> ${getPlainLabel(
                  el.label,
                )}`,
              });
            });
            return;
          }

          if (qa.field_type === "checkboxes") {
            // find answers
            const answers = res.data.answerQuestions.filter(
              (ans) => ans?.question?.id === qa.id,
            );

            const finalData = answers.map((answer) => ({
              answer: answer?.question_option?.label,
              answer_id: answer?.question_option?.id,
              field_type: qa.field_type,
              id: qa.id,
              question: qa.label,
            }));
            all.push(...finalData);

            return;
          }

          // answer
          const answer = res.data.answerQuestions.find(
            (ans) => ans?.question?.id === qa.id,
          );
          all.push({
            answer: answer?.value ?? answer?.question_option?.label,
            answer_id: answer?.question_option
              ? answer?.question_option?.id
              : null,
            field_type: qa.field_type,
            id: qa.id,
            question: qa?.parentLabel
              ? `${qa?.parentLabel} => ${getPlainLabel(qa.label)}`
              : getPlainLabel(qa.label),
          });
        });
        setQuestionAnswers(all);

        setFormId(res.data.form.id);
        getIgnoreFlagsList(res.data.form.id);
        setQuestionToFlags([]);
        setQuestionToTypes([]);
        setUserData({
          first_name: res.data.user.firstname,
          last_name: res.data.user.lastname,
          mobile: res.data.user.username,
        });
        setEpollId(100);
        setRoadmapId(res.data.roadmap.id);
        ClearLoading();
        setIsFetchedData(true);
      })
      .catch(() => {
        ClearLoading();
      });
  };

  const mapPreAndPostConditionFlags = (
    targetFlag,
    preConditionFlags,
    postConditionFlags,
    newFlags,
    extraData,
  ) => {
    if (
      targetFlag.preConditionFlags.length === 0 &&
      targetFlag.postConditionFlags.length === 0
    ) {
      return;
    }

    const mapPreConditionFlags = (flag) => {
      flag.preConditionFlags.forEach((el) => {
        const flagRef = findFlagRef(el, flags);
        if (flagRef) {
          if (flagRef.id == flag.postConditionGenerated?.id) {
            return;
          }

          flagRef.preConditionGenerated = flag;
          flagRef.addedUser = operatorData;
          flagRef.addedDate = new Date();
          newFlags.splice(flags.indexOf(flagRef), 1);
          preConditionFlags.push({ ...flagRef, ...extraData });
          if (
            Array.isArray(flagRef.preConditionFlags) &&
            flagRef.preConditionFlags.length > 0
          ) {
            setTimeout(() => {
              mapPreConditionFlags(flagRef);
            }, 1);
          }
          if (
            Array.isArray(flagRef.postConditionFlags) &&
            flagRef.preConditionFlags.length > 0
          ) {
            setTimeout(() => {
              mapPostConditionFlags(flagRef);
            }, 1);
          }
        }
      });
    };
    const mapPostConditionFlags = (flag) => {
      flag.postConditionFlags.forEach((el) => {
        const flagRef = findFlagRef(el, flags);
        if (flagRef) {
          if (flagRef.id == flag.preConditionGenerated?.id) {
            return;
          }

          flagRef.postConditionGenerated = flag;
          flagRef.addedUser = operatorData;
          flagRef.addedDate = new Date();
          newFlags.splice(flags.indexOf(flagRef), 1);
          postConditionFlags.push({ ...flagRef, ...extraData });
          if (
            Array.isArray(flagRef.preConditionFlags) &&
            flagRef.preConditionFlags.length > 0
          ) {
            setTimeout(() => {
              mapPreConditionFlags(flagRef);
            }, 1);
          }
          if (
            Array.isArray(flagRef.postConditionFlags) &&
            flagRef.preConditionFlags.length > 0
          ) {
            setTimeout(() => {
              mapPostConditionFlags(flagRef);
            }, 1);
          }
        }
      });
    };
    if (targetFlag.preConditionFlags.length > 0) {
      mapPreConditionFlags(targetFlag);
    }
    if (targetFlag.postConditionFlags.length > 0) {
      mapPostConditionFlags(targetFlag);
    }
  };

  const unBookmarkRemoveFlags = (questionId) => {
    const newTerms = structuredClone(terms);
    Object.keys(newTerms).forEach((key) => {
      const newFlags = [];
      terms[key].flags.forEach((flag) => {
        if (
          `${flag.bookmarkCondition}` === `${questionId}` ||
          `${flag.bookmarkQuestionId}` === `${questionId}`
        ) {
          return;
        } else {
          newFlags.push(flag);
        }
      });
      newTerms[key].flags = newFlags;
    });
    setTerms(newTerms);
    removeUsedFlags(newTerms);
    setIsRoadmapChanged(true);
  };

  const insertQuestionFlagsToRoadmap_V00 = (
    questionFlags,
    question,
    questionId,
  ) => {
    let newFlags = structuredClone(Array.from(flags));
    console.log("bookmark data: newFlags", {
      newFlags,
      flags,
      questionFlags,
      question,
      questionId,
    });

    const newTerms = structuredClone(terms);
    let allTermsFlags = [
      newTerms?.term1?.flags,
      newTerms?.term2?.flags,
      newTerms?.term3?.flags,
      newTerms?.term4?.flags,
    ];
    let allTermsDestructedFlags = [
      ...newTerms?.term1?.flags,
      ...newTerms?.term2?.flags,
      ...newTerms?.term3?.flags,
      ...newTerms?.term4?.flags,
    ];

    let addedFlags = [];
    for (const flagId of questionFlags) {
      const flag = findFlagRef({ id: +flagId }, newFlags);
      if (!flag) continue;

      newFlags = newFlags.filter((el) => el.id !== flag.id);

      const addedFlag = {
        ...flag,
        bookmarkGenerated: question,
        bookmarkQuestionId: questionId,
        addedUser: operatorData,
        addedDate: new Date(),
      };
      const preConditionFlags = [];
      const postConditionFlags = [];
      mapPreAndPostConditionFlags(
        flag,
        preConditionFlags,
        postConditionFlags,
        newFlags,
        { bookmarkCondition: questionId },
      );
      // addedFlags.push(...preConditionFlags, addedFlag, ...postConditionFlags);
      addedFlags.push(addedFlag);
    }

    // all flags -> main + all pre + all post

    let current = [...addedFlags];
    console.log({ current, addedFlags });
    const allExistingFlags = new Set([...allRoadmapFlags, ...current]);
    // for (let index = 0; index < 100; index++) {
    //   const tempFF = [];
    //   current.forEach((flag) => {
    //     const post = flag?.postConditionFlags
    //       ?.map((el) => findFlagRef(el, flags))
    //       .filter((fl) => fl.hidden);
    //     const pre = flag?.preConditionFlags
    //       ?.map((el) => findFlagRef(el, flags))
    //       .filter((fl) => fl.hidden);

    //     const temp = [...post, ...pre]
    //       .filter((ac) => !addedFlags.find((obj) => obj?.id === ac?.id))
    //       .filter((c) => c);

    //     addedFlags.push(...temp);
    //     tempFF.push(...temp);
    //   });

    //   if (tempFF.length === 0) break;
    //   current = tempFF;
    // }

    addedFlags = addedFlags.map((flag, _, clone) => {
      if (
        flag?.bookmarkQuestionId ||
        flag.addedUser ||
        flag.autoGenerated ||
        flag.postConditionGenerated ||
        flag.preConditionGenerated
      ) {
        return flag;
      }

      const post = clone
        .filter((d) => d.postConditionFlags.find((a) => a.id === flag.id))
        .map(({ id, title }) => ({ id, title }));

      const pre = clone
        .filter((d) => d.preConditionFlags.find((a) => a.id === flag.id))
        .map(({ id, title }) => ({ id, title }));

      return {
        ...flag,
        report: {
          pre: pre.filter((e) => allExistingFlags.has(e.id)),
          post: post.filter((e) => allExistingFlags.has(e.id)),
        },
        addedUser: operatorData,
        addedDate: new Date(),
      };
    });
    console.warn("bookmark", { addedFlags });

    const uniqueIds = [];
    addedFlags = addedFlags.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.id);

      if (!isDuplicate) {
        uniqueIds.push(element.id);

        return true;
      }

      return false;
    });

    addedFlags = addedFlags.map((el, _, clone) => {
      const flagRef = findFlagRef(el, flagsClone);
      return {
        ...el,
        postConditionFlags: flagRef.postConditionFlags.filter((e) =>
          [...clone, ...allTermsDestructedFlags].find((i) => i.id === e.id),
        ),
        preConditionFlags: flagRef.preConditionFlags.filter((e) =>
          [...clone, ...allTermsDestructedFlags].find((i) => i.id === e.id),
        ),
      };
    });

    addedFlags = ignoreFlagsFromGenerator(addedFlags);

    console.log("ignoreFlagsFromGenerator", { addedFlags });

    const mainFlags = addedFlags.filter((el) => el?.bookmarkQuestionId);
    console.log({ mainFlags });
    const nonMainFlags = addedFlags.filter(
      ({ id }) => !mainFlags.find((el) => el.id === id),
    );

    console.log({ nonMainFlags });

    // just include pre that are in Main level
    let mainFlagsWithMinorPre = mainFlags.map((flag, _, clone) => {
      const preOfOther = [...clone, ...allTermsDestructedFlags].filter((fl) =>
        fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [
          ...preOfOther,
          ...flag.preConditionFlags.filter(({ id }) =>
            [...clone, ...allTermsDestructedFlags].find((val) => val.id === id),
          ),
        ],
      };
    });
    console.log({ mainFlagsWithMinorPre });

    // just include pre that are in non-Main level
    let nonMainFlagsWithMinorPre = nonMainFlags.map((flag) => {
      const preOfOther = [...addedFlags, ...allTermsDestructedFlags].filter(
        (fl) => fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [...preOfOther, ...flag.preConditionFlags].filter(
          ({ id }) =>
            [...addedFlags, ...allTermsDestructedFlags].find(
              (val) => val.id === id,
            ),
        ),
      };
    });
    console.log({ nonMainFlagsWithMinorPre });

    // just include post that are in non-Main level
    let nonMainFlagsWithMinorPost = addedFlags.map((flag) => {
      const postOfOther = [...addedFlags, ...allTermsDestructedFlags].filter(
        (fl) => fl.preConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [...postOfOther, ...flag.postConditionFlags],
        preConditionFlags: [],
      };
    });
    console.log({ nonMainFlagsWithMinorPost });

    // sort main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      let targetFlag = mainFlagsWithMinorPre.find((fl) => {
        const preFlags = fl.preConditionFlags.map(({ id }) => id);
        // are flags rendered
        return isAllFlagsAddedToTerms(preFlags, allTermsFlags);
      });
      console.log({ targetFlag });

      if (!targetFlag) break;

      const flagRef = findFlagRef(targetFlag, flagsClone);
      targetFlag = {
        ...targetFlag,
        // postConditionFlags: flagRef.postConditionFlags,
        // preConditionFlags: flagRef.preConditionFlags,

        postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
          allExistingFlags.has(id),
        ),
        preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
          allExistingFlags.has(id),
        ),
      };
      console.log({ flagRef, targetFlag });

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };
      console.log({ placement });

      // check manual placement
      let manualTermIndex = termIndexFinderForBookmark(
        questionId,
        targetFlag.id,
      );

      const isManualExists = manualTermIndex || manualTermIndex === 0;
      console.log({ manualTermIndex, isManualExists });

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 1 : manualTermIndex - 1;
      }

      const conditions = findTermAndIndexOfPreOfFlag(targetFlag, allTermsFlags);
      console.log({ conditions });

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.max(...conditions.map((val) => val.termIndex));
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const cc = conditions
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        tempFlagIndex = allTermsFlags[placement.termIndex].length - 1;
        if (cc.length !== 0) {
          tempFlagIndex = Math.max(...cc);
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      } else {
        placement.termIndex = isManualExists ? manualTermIndex : 1;
        placement.flagIndex = allTermsFlags[placement.termIndex].length - 1;
      }

      console.log("bookmark - main flags", {
        targetFlag,
        conditions,
        isManualExists,
        manualTermIndex,
        placement,
      });

      console.log({ allTermsFlags });
      // insert flag into terms
      allTermsFlags = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: allTermsFlags,
      });
      console.log("reach2");

      // remove from mainFlagsWithMinorPostPre
      mainFlagsWithMinorPre = mainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    // sort non-main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      let targetFlag = nonMainFlagsWithMinorPre.find((fl) => {
        const preFlags = fl.preConditionFlags.map(({ id }) => id);
        if (preFlags.length === 0) return false;
        // are flags rendered
        return isOneOfFlagsAddedToTerms(preFlags, allTermsFlags);
      });

      console.log({ targetFlag });
      if (!targetFlag) break;

      const flagRef = findFlagRef(targetFlag, flagsClone);

      targetFlag = {
        ...targetFlag,
        postConditionFlags: flagRef.postConditionFlags,
        preConditionFlags: flagRef.preConditionFlags,
      };
      console.log({ flagRef, targetFlag });

      // check conditions
      const placement = { termIndex: 0, flagIndex: 0 };
      const conditions = findTermAndIndexOfPreOfFlag(targetFlag, allTermsFlags);
      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        const tempTermIndex = Math.max(
          ...conditions.map((val) => val.termIndex),
        );
        // find max of flagIndex from preConditions
        const tempFlagIndex = Math.max(
          ...conditions
            .filter((c) => c.termIndex === tempTermIndex)
            .map((val) => val.flagIndex),
        );

        placement.termIndex = tempTermIndex;
        placement.flagIndex = tempFlagIndex;
      }

      // insert flag into terms
      allTermsFlags = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: allTermsFlags,
      });

      console.log("bookmark: non-main flags 01 - pre", {
        targetFlag,
        allTermsFlags,
        conditions,
        placement,
      });

      // remove from mainFlagsWithMinorPre
      nonMainFlagsWithMinorPre = nonMainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
      console.log({ nonMainFlagsWithMinorPre });
    }

    // filter non-main flags with post relation that not exists in rendered list
    nonMainFlagsWithMinorPost = nonMainFlagsWithMinorPost.filter(
      ({ id }) =>
        !allTermsFlags.find((term) => term.find((fl) => fl.id === id)),
    );

    // sort non-main flags -> base on post
    console.log({ nonMainFlagsWithMinorPost });
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      let targetFlag = nonMainFlagsWithMinorPost.find((fl) => {
        const postFlags = fl.postConditionFlags.map(({ id }) => id);
        if (postFlags.length === 0) return false;
        // check is one flag rendered
        return isOneOfFlagsAddedToTerms(postFlags, allTermsFlags);
      });

      if (!targetFlag) break;

      const flagRef = findFlagRef(targetFlag, flagsClone);
      targetFlag = {
        ...targetFlag,
        postConditionFlags: flagRef.postConditionFlags,
        preConditionFlags: flagRef.preConditionFlags,
      };

      // check conditions
      const placement = { termIndex: 0, flagIndex: 0 };
      const conditions = findTermAndIndexOfPostOfFlag(
        targetFlag,
        allTermsFlags,
      );
      console.log({ flagRef, targetFlag, placement, conditions });
      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        const tempTermIndex = Math.min(
          ...conditions.map((val) => val.termIndex),
        );
        // find max of flagIndex from preConditions
        const tempFlagIndex = Math.min(
          ...conditions
            .filter((c) => c.termIndex === tempTermIndex)
            .map((val) => val.flagIndex),
        );

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      }

      // insert flag into terms
      allTermsFlags = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex - 1,
        terms: allTermsFlags,
      });

      console.log("bookmark: non-main flags 02 - post", {
        targetFlag,
        conditions,
        placement,
      });

      // remove from mainFlagsWithMinorPostPre
      nonMainFlagsWithMinorPost = nonMainFlagsWithMinorPost.filter(
        ({ id }) => id !== targetFlag.id,
      );
      console.log({ nonMainFlagsWithMinorPost });
    }

    setIsRoadmapChanged(true);
    setTerms(newTerms);
    removeUsedFlags(newTerms);
    setTimeout(() => {
      setUpdateForcer(updateForcer + 1);
    });

    setIsRoadmapChanged(true);
  };

  const insertQuestionFlagsToRoadmap = (
    questionFlags,
    question,
    questionId,
  ) => {
    let newFlags = structuredClone(Array.from(flags));
    console.log("bookmark data: newFlags", {
      newFlags,
      flags,
      questionFlags,
      question,
      questionId,
    });

    const newTerms = structuredClone(terms);
    const flagRef = findFlagRef({ id: +questionFlags.at(0) }, newFlags);

    const targetFlag = {
      ...flagRef,
      bookmarkGenerated: question,
      bookmarkQuestionId: questionId,
      addedUser: operatorData,
      addedDate: new Date(),
    };

    let allTermsFlags = [
      newTerms?.term1?.flags,
      newTerms?.term2?.flags,
      newTerms?.term3?.flags,
      newTerms?.term4?.flags,
    ];

    const preOfThisFlagIdList = [
      ...targetFlag.postConditionFlags.map((e) => e.id),
      ...allRoadmapFlags.filter((id) =>
        findFlagRef({ id }, newFlags)?.preConditionFlags?.find(
          (e) => e.id === targetFlag.id,
        ),
      ),
    ].filter((e) => allRoadmapFlags.includes(e));

    const postOfThisFlagIdList = [
      ...targetFlag.preConditionFlags.map((e) => e.id),
      ...allRoadmapFlags.filter((id) =>
        findFlagRef({ id }, newFlags)?.postConditionFlags?.find(
          (e) => e.id === targetFlag.id,
        ),
      ),
    ].filter((e) => allRoadmapFlags.includes(e));

    // check conditions

    const placement = {
      termIndex: termIndexFinderForBookmark(questionId, targetFlag.id) ?? 2,
      flagIndex: 0,
    };

    const shouldBePreOfThisCond = preOfThisFlagIdList.map((id) =>
      findFlagPositionFromArrayTerms(id, allTermsFlags),
    );

    const shouldBePostOfThisCond = postOfThisFlagIdList.map((id) =>
      findFlagPositionFromArrayTerms(id, allTermsFlags),
    );

    console.log({ placement, shouldBePreOfThisCond, shouldBePostOfThisCond });
    if (shouldBePostOfThisCond.length > 0) {
      const termIndex = Math.max(
        ...shouldBePreOfThisCond.map((val) => val.termIndex),
        placement.termIndex,
      );
      const flagIndex = Math.max(
        ...shouldBePreOfThisCond
          .filter((e) => e.termIndex === termIndex)
          .map((val) => val.flagIndex),
        placement.flagIndex,
      );

      placement.termIndex = termIndex;
      placement.flagIndex = flagIndex;
    }

    if (shouldBePreOfThisCond.length > 0) {
      const termIndex = Math.min(
        ...shouldBePreOfThisCond.map((val) => val.termIndex),
        placement.termIndex,
      );
      const flagIndex = Math.min(
        Math.min(
          ...shouldBePreOfThisCond
            .filter((e) => e.termIndex === termIndex)
            .map((val) => val.flagIndex),
        ) - 1,
        placement.flagIndex,
      );

      placement.termIndex = termIndex;
      placement.flagIndex = flagIndex;
    }

    // insert flag into terms
    allTermsFlags = insertFlagIntoTerm({
      flag: targetFlag,
      termIndex: placement.termIndex,
      colIndex: placement.flagIndex,
      terms: allTermsFlags,
    });

    // hidden Flags starts

    console.log({
      a: flagRef,
      b: flagRef.preConditionFlags.map((e) => findFlagRef(e, newFlags)),
    });
    const hiddenFlags = flagRef.preConditionFlags
      .map((e) => findFlagRef(e, newFlags))
      .filter((e) => e && e.hidden && !allRoadmapFlags.includes(e?.id));

    console.log({ hiddenFlags });

    // sort hidden flags
    for (const targetFlag of hiddenFlags) {
      const shouldBePreOfThisFlagsId = [flagRef.id, ...allRoadmapFlags].filter(
        (id) =>
          findFlagRef({ id }, newFlags)?.preConditionFlags?.find(
            (e) => e.id === targetFlag.id,
          ),
      );

      const conditions = shouldBePreOfThisFlagsId.map((id) =>
        findFlagPositionFromArrayTerms(id, allTermsFlags),
      );

      console.log({
        shouldBePreOfThisFlagsId,
        conditions,
        allRoadmapFlags,
      });
      const termIndex = Math.min(...conditions.map((val) => val.termIndex));
      const flagIndex = Math.min(
        ...conditions
          .filter((e) => e.termIndex === termIndex)
          .map((val) => val.flagIndex),
      );

      const insertingFlag = {
        ...targetFlag,
        report: {
          pre: allRoadmapFlags
            .map((id) => findFlagRef({ id }, newFlags))
            .filter((fl) =>
              fl?.preConditionFlags?.find((e) => e.id === targetFlag.id),
            )
            .map((e) => ({ id: e.id, title: e.title })),
          post: allRoadmapFlags
            .map((id) => findFlagRef({ id }, newFlags))
            .filter((fl) =>
              fl?.postConditionFlags?.find((e) => e.id === targetFlag.id),
            )
            .map((e) => ({ id: e.id, title: e.title })),
        },
      };

      // insert flag into terms
      allTermsFlags = insertFlagIntoTerm({
        flag: insertingFlag,
        termIndex: conditions.length === 0 ? 0 : termIndex,
        colIndex: conditions.length === 0 ? 0 : flagIndex - 1,
        terms: allTermsFlags,
      });
    }

    setTerms(newTerms);
    setFlags((prev) => getUnusedFlags(newTerms, prev));
  };

  const unGeneratorRemoveFlags = () => {
    const newTerms = structuredClone(terms);
    Object.keys(newTerms).forEach((key) => {
      const newFlags = [];
      terms[key].flags.forEach((flag) => {
        if (!flag.autoGenerated && !flag.autoGeneratedCondition) {
          newFlags.push(flag);
        }
      });
      newTerms[key].flags = newFlags;
    });
    setTerms(newTerms);
    removeUsedFlags(newTerms);
    setIsRoadmapChanged(true);
  };

  const loadFlagPlacements = (id) => {
    api.get("/flags-relation/" + id).then(({ data }) => {
      setTempFlagsPos(
        data.map((i) => ({
          value: i.termIndex,
          flagId: i.flag,
          id: i.question_id,
          answer_id: i.answer_id,
          importance: i.importance ?? 0,
          // id: i.answer_id,
          // answer_id: i.question_id,
        })),
      );
    });
  };

  const termIndexFinder = (questionId, flagId, answerId) => {
    // search base on -> questionId, flagId, answerId
    if (answerId) {
      const first = tempFlagsPos.find(
        (i) =>
          i.id == questionId && flagId == i.flagId && answerId == i.answer_id,
      );

      if (first) return first.value;
    }

    // search base on -> questionId, flagId
    const second = tempFlagsPos.find(
      (i) => i.id == questionId && flagId == i.flagId && i.answer_id === null,
    );

    if (second) return second.value;

    // return default
    return -1;
  };

  const termIndexFinderForGenerator = (questionId, flagId, answerId) => {
    const val = tempFlagsPos.find(
      (i) =>
        `${i.id}` === `${questionId}` &&
        `${flagId}` === `${i.flagId}` &&
        `${i.answer_id}` === `${answerId}`,
    );
    return val?.value;
  };

  const termIndexFinderForBookmark = (questionId, flagId) => {
    const val = tempFlagsPos.find(
      (i) =>
        `${i.id}` === `${questionId}` &&
        `${flagId}` === `${i.flagId}` &&
        i.answer_id === null,
    );
    return val?.value;
  };

  const ignoreFlagsFromGenerator = (flags = []) => {
    const ignoredFlagsUniqueId = new Set();

    ignoreFlags
      .filter((qa) => qa.answer?.trim() !== "" && qa.answer_id)
      .filter((cond) =>
        questionAnswers.find(
          (qa) =>
            `${qa.answer_id}` === `${cond.answer_id}` &&
            `${qa.id}` === `${cond.question_id}`,
        ),
      )
      .forEach((el) => ignoredFlagsUniqueId.add(el?.bom_item?.id));

    return flags
      .filter((flag) => !ignoredFlagsUniqueId.has(flag.id))
      .map((flag) => {
        return {
          ...flag,
          postConditionFlags: flag?.postConditionFlags?.filter(
            (fl) => !ignoredFlagsUniqueId.has(fl.id),
          ),
          preConditionFlags: flag?.preConditionFlags?.filter(
            (fl) => !ignoredFlagsUniqueId.has(fl.id),
          ),
        };
      });
  };

  const getIgnoreFlagsList = (id) => {
    api
      .get(`/question-ignore-flag/${id}`)
      .then((res) => setIgnoreFlags(res.data))
      .catch(() => message.error("خطا در دریافت کارت های حذفی"));
  };

  const flagIgnoredByGenerator = (id) => {
    const notIgnoreList = ignoreFlagsFromGenerator([{ id }]);

    return !notIgnoreList.find((e) => e.id == id);
  };

  const shuffleSoloFlags = (orgTerms) => {
    console.log("-------------------shuffle function v2--------------------");

    const terms = { ...orgTerms };

    console.log("beforeShuffle", { terms });

    for (let termIndex = 1; termIndex < 5; termIndex++) {
      console.warn(`-------------------term ${termIndex}--------------------`);
      // extract flags with no pre and post in same column     ->     this flags can move between this term rows
      let exportedFlags = terms[`term${termIndex}`].flags.filter(
        (flagLoop, index, clone) => {
          const flag = findFlagRef(flagLoop, flags);

          const cond1 = !clone.find((fl) => {
            const flagRef = findFlagRef(fl, flags);
            const postOfAnyOne = flagRef.postConditionFlags.find(
              (eFlag) => eFlag.id === flag.id,
            );
            const preOfAnyOne = flagRef.preConditionFlags.find(
              (eFlag) => eFlag.id === flag.id,
            );
            return postOfAnyOne || preOfAnyOne;
          });
          const cond2 = !flag.postConditionFlags.find(({ id }) => {
            return clone.find((fl) => fl.id === id);
          });
          const cond3 = !flag.preConditionFlags.find(({ id }) =>
            clone.find((fl) => fl.id === id),
          );

          const finalCond = cond1 && cond2 && cond3;

          return finalCond;
        },
      );

      console.log({ exportedFlags });

      // check any flag exists?
      if (exportedFlags.length === 0) continue;

      // remove last step flags from this term     ->     this flags are locked in their position
      let newTermFlags = terms[`term${termIndex}`].flags.filter(
        (eFlag) => !exportedFlags.find((iFlag) => eFlag.id === iFlag.id),
      );

      console.log({ newTermFlags });

      for (const eF of exportedFlags) {
        let flagRef = newTermFlags.find((flag, _fIndx, clone) => {
          // ignore last item in term
          if (_fIndx === clone.length - 1) return false;

          const nextFlag = clone[_fIndx + 1];

          // check current flag and next one are pre-post requirement
          if (flag?.hidden || nextFlag?.hidden) {
            const preCondInNextFlag = nextFlag?.preConditionFlags?.find(
              (obj) => obj.id === flag.id,
            );
            const postCondInPrevFlag = flag?.postConditionFlags?.find(
              (obj) => obj.id === nextFlag.id,
            );

            if (preCondInNextFlag || postCondInPrevFlag) return false;
          }

          return (
            !flag.hidden &&
            !nextFlag.hidden &&
            flag.type === nextFlag.type &&
            eF.type !== flag.type
          );
        });

        if (!flagRef) {
          flagRef = newTermFlags.find((flag, _fIndx, clone) => {
            // check if its last
            if (_fIndx === clone.length - 1) return eF.type !== flag.type;

            const nextFlag = clone[_fIndx + 1];

            return (
              !flag?.hidden &&
              !nextFlag?.hidden &&
              flag.type !== eF.type &&
              nextFlag.type !== eF.type
            );
          });
        }

        let flagIndex = -1;
        try {
          for (let wIndex = 0; wIndex < newTermFlags.length; wIndex++) {
            if (newTermFlags[wIndex].id === flagRef.id) {
              flagIndex = wIndex;
              break;
            }
          }
        } catch (error) {}

        newTermFlags.splice(flagIndex + 1, 0, eF);
      }

      terms[`term${termIndex}`].flags = newTermFlags;
    }
    return terms;
  };

  const insertAnswersFlagsToRoadmap = () => {
    setGeneratorUsed(true);
    if (epollRecordId) {
      return insertAnswersFlagsToRoadmap_OLD();
    } else {
      return insertAnswersFlagsToRoadmap_NEW();
    }
  };

  const insertAnswersFlagsToRoadmap_OLD_V0 = () => {
    console.log("generator lunched-8_old");

    // check array exists
    if (!Array.isArray(questionAnswers)) return;

    console.log({ questionAnswers });
    const newTerms = structuredClone(terms);
    let finalTerms = [[], [], [], []];
    let mainFlags = [];

    // set terms title
    const titleNames = getMonthNames();
    newTerms.term1.title = titleNames.term1;
    newTerms.term2.title = titleNames.term2;
    newTerms.term3.title = titleNames.term3;
    newTerms.term4.title = titleNames.term4;

    questionAnswers.forEach((qa) => {
      let answerFlags = [];
      let questionAnswer = null;

      questionToFlags.forEach((el) => {
        if (
          qa.answer_id &&
          `${el.epollAnswerId}` === `${qa.answer_id}` &&
          `${el.epollQuestionId}` === `${qa.id}`
        ) {
          answerFlags = el.flags;
          questionAnswers.forEach((question) => {
            if (
              `${el.epollAnswerId}` === `${question.answer_id}` &&
              `${el.epollQuestionId}` === `${question.id}`
            ) {
              questionAnswer = question;
            }
          });
        }
      });

      const addedFlags = [];
      if (Array.isArray(answerFlags)) {
        flags.forEach((flag) => {
          answerFlags.forEach((id) => {
            if (`${flag.id}` === `${id}`) {
              addedFlags.push({
                ...flag,
                autoGenerated: questionAnswer,
                addedUser: operatorData,
                addedDate: new Date(),
              });
            }
          });
        });
      }

      const uniqueIds = [];
      const unique = addedFlags?.filter((element) => {
        if (!uniqueIds.includes(element.id)) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
      mainFlags.push(...unique);
    });

    const uniqueMainId = new Set();
    mainFlags = mainFlags.filter(({ id }) => {
      if (uniqueMainId.has(id)) return false;
      uniqueMainId.add(id);
      return true;
    });

    mainFlags = ignoreFlagsFromGenerator(mainFlags);

    // all flags -> main + all pre + all post
    let allFlags = [...mainFlags];
    let current = [...mainFlags];
    for (let index = 0; index < 100; index++) {
      const tempFF = [];
      current.forEach((flag) => {
        const post = flag?.postConditionFlags?.map((el) =>
          findFlagRef(el, flags),
        );
        const pre = flag?.preConditionFlags?.map((el) =>
          findFlagRef(el, flags),
        );

        const temp = [...post, ...pre].filter(
          (ac) => !allFlags?.find((obj) => obj?.id === ac?.id),
        );

        allFlags.push(...temp);
        tempFF.push(...temp);
      });

      if (tempFF.length === 0) break;
      current = tempFF;
    }

    allFlags = ignoreFlagsFromGenerator(allFlags);

    const nonMainFlags = allFlags.filter(
      ({ id }) => !mainFlags.find((el) => el.id === id),
    );

    const flagsReport = allFlags.map((fl, index, clone) => {
      const pre = clone.filter((c) =>
        c.preConditionFlags.find(({ id }) => id === fl.id),
      );
      const post = clone.filter((c) =>
        c.postConditionFlags.find(({ id }) => id === fl.id),
      );

      return {
        ...findFlagRef(fl, flags),
        index,
        post,
        pre,
      };
    });

    // just include pre that are in Main level
    let mainFlagsWithMinorPre = mainFlags.map((flag, _, clone) => {
      const preOfOther = clone.filter((fl) =>
        fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [...preOfOther, ...flag.preConditionFlags].filter(
          ({ id }) => clone.find((val) => val.id === id),
        ),
      };
    });

    // just include pre that are in non-Main level
    let nonMainFlagsWithMinorPre = nonMainFlags.map((flag) => {
      const preOfOther = allFlags.filter((fl) =>
        fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [...preOfOther, ...flag.preConditionFlags].filter(
          ({ id }) => allFlags.find((val) => val.id === id),
        ),
      };
    });

    // just include post that are in non-Main level
    let nonMainFlagsWithMinorPost = nonMainFlags.map((flag) => {
      const postOfOther = allFlags.filter((fl) =>
        fl.preConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [
          ...postOfOther,
          ...flag.postConditionFlags.filter(({ id }) =>
            allFlags.find((val) => val.id === id),
          ),
        ],
        preConditionFlags: [],
      };
    });

    console.log({ mainFlags });

    // sort main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = mainFlagsWithMinorPre.find((fl) => {
        const preFlags = fl.preConditionFlags.map(({ id }) => id);
        // are flags rendered
        return isAllFlagsAddedToTerms(preFlags, finalTerms);
      });

      if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };

      // check manual placement
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = [];
      for (const qa of relatedQuestionsForTermIndex) {
        const tempoIndex = termIndexFinderForGenerator(
          qa?.id,
          targetFlag.id,
          qa?.answer_id,
        );

        if (tempoIndex) tempTermIndex.push(tempoIndex);
      }
      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      console.log({
        targetFlag,
        relatedQuestionsForTermIndex,
        isManualExists,
        tempTermIndex,
        manualTermIndex,
      });

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }

      const conditions = findTermAndIndexOfPreOfFlag(targetFlag, finalTerms);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.max(...conditions.map((val) => val.termIndex));
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const cc = conditions
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        if (cc.length !== 0) {
          tempFlagIndex = Math.max(...cc);
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      } else {
        placement.termIndex = isManualExists ? manualTermIndex : 2;
      }

      console.log("main flags", {
        targetFlag,
        conditions,
        isManualExists,
        manualTermIndex,
        placement,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlagsWithMinorPre = mainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    // sort non-main flags -> base on pre
    console.log({ nonMainFlagsWithMinorPre });
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = nonMainFlagsWithMinorPre.find((fl) => {
        const preFlags = fl.preConditionFlags.map(({ id }) => id);
        if (preFlags.length === 0) return false;
        // are flags rendered
        return isOneOfFlagsAddedToTerms(preFlags, finalTerms);
        // return isAllFlagsAddedToTerms(preFlags, finalTerms);
      });

      if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 0, flagIndex: 0 };
      const conditions = findTermAndIndexOfPreOfFlag(targetFlag, finalTerms);
      const cond2 = findTermAndIndexOfPreOfFlagBaseOnMainFlag(
        targetFlag,
        finalTerms,
      );
      const con3 = conditions.length !== 0;
      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        const tempTermIndex = Math.max(
          ...conditions.map((val) => val.termIndex),
        );
        // find max of flagIndex from preConditions
        const tempFlagIndex = Math.max(
          ...conditions
            .filter((c) => c.termIndex === tempTermIndex)
            .map((val) => val.flagIndex),
        );

        placement.termIndex = tempTermIndex;
        placement.flagIndex = tempFlagIndex;
      }

      if (cond2.length !== 0) {
        // find min of termIndex from preConditions
        const tempTermIndex2 = Math.min(...cond2.map((val) => val.termIndex));
        // find max of flagIndex from preConditions
        const tempFlagIndex2 = Math.min(
          ...cond2
            .filter((c) => c.termIndex === tempTermIndex2)
            .map((val) => val.flagIndex),
        );

        if (con3) {
          if (
            placement.termIndex > tempTermIndex2 ||
            (placement.termIndex === tempTermIndex2 &&
              placement.flagIndex > tempFlagIndex2)
          ) {
            message.error(`${targetFlag.title} خطا در کارت`);
          }
        }
        placement.termIndex = tempTermIndex2;
        placement.flagIndex = tempFlagIndex2 - 1;
      }

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      console.log("non-main flags 01 - pre", {
        targetFlag,
        conditions,
        placement,
      });

      // remove from mainFlagsWithMinorPre
      nonMainFlagsWithMinorPre = nonMainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    // filter non-main flags with post relation that not exists in rendered list
    nonMainFlagsWithMinorPost = nonMainFlagsWithMinorPost.filter(
      ({ id }) => !finalTerms.find((term) => term.find((fl) => fl.id === id)),
    );

    // sort non-main flags -> base on post
    console.log({ nonMainFlagsWithMinorPost });
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = nonMainFlagsWithMinorPost.find((fl) => {
        const postFlags = fl.postConditionFlags.map(({ id }) => id);
        if (postFlags.length === 0) return false;
        // check is one flag rendered
        // return isOneOfFlagsAddedToTerms(postFlags, finalTerms);
        return isAllFlagsAddedToTerms(postFlags, finalTerms);
      });

      if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 0, flagIndex: 0 };
      const conditions = findTermAndIndexOfPostOfFlag(targetFlag, finalTerms);
      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        const tempTermIndex = Math.min(
          ...conditions.map((val) => val.termIndex),
        );
        // find max of flagIndex from preConditions
        const tempFlagIndex = Math.min(
          ...conditions
            .filter((c) => c.termIndex === tempTermIndex)
            .map((val) => val.flagIndex),
        );

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      }

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex - 1,
        terms: finalTerms,
      });

      console.log("non-main flags 02 - post", {
        targetFlag,
        conditions,
        placement,
      });

      // remove from mainFlagsWithMinorPostPre
      nonMainFlagsWithMinorPost = nonMainFlagsWithMinorPost.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    const allUniqueId = new Set(allFlags.map(({ id }) => id));
    const allMainUniqueId = new Set(mainFlags.map(({ id }) => id));

    for (let index = 0; index < finalTerms.length; index++) {
      finalTerms[index] = finalTerms[index].map((flag, i) => {
        const isMainFlag = allMainUniqueId.has(flag.id);

        const flagRef = findFlagRef({ id: flag.id }, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);

        if (!isMainFlag) {
          // find all post
          return {
            ...flagRef,
            report: {
              post: fReport?.post?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null,
              ),
              pre: fReport.pre?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null,
              ),
            },
            addedDate: new Date(),
            addedUser: operatorData,
            autoGenerated: {},
          };
        }

        const relatedQuestions = questionToFlags
          .filter((val) => val.flags.includes(flagRef.id))
          .filter((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.epollQuestionId}` &&
                `${qa.answer_id}` === `${a.epollAnswerId}`,
            );
          })
          .map((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.epollQuestionId}` &&
                `${qa.answer_id}` === `${a.epollAnswerId}`,
            );
          })
          .filter((q) => q?.answer !== "" && q?.answer_id !== null);

        console.log({ relatedQuestions });

        return {
          ...flag,
          addedDate: new Date(),
          addedUser: operatorData,
          postConditionFlags: flagRef.postConditionFlags,
          preConditionFlags: flagRef.preConditionFlags,
          report: {
            post: fReport.post?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null,
            ),
            pre: fReport.pre?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null,
            ),
          },
          autoGenerated: { ...flag.autoGenerated, relatedQuestions },
        };
      });
      newTerms[`term${index + 1}`].flags = finalTerms[index];
    }

    // sort other flags that have bug
    const conflictFlags = allFlags
      .filter(({ id }) => !allUniqueId.has(id))
      .map((flag) => {
        const finalFlag = findFlagRef(flag, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);
        return {
          ...finalFlag,
          addedDate: new Date(),
          addedUser: operatorData,
          report: { post: fReport.post, pre: fReport.pre },
          autoGenerated: { ...flag?.autoGenerated, conflict: true },
        };
      });
    newTerms[`term3`].flags = [...conflictFlags, ...newTerms[`term3`].flags];

    const shuffleTerms = shuffleSoloFlags(newTerms);

    // map termIndex to each
    for (let t = 0; t < 4; t++) {
      newTerms[`term${t + 1}`].flags = newTerms[`term${t + 1}`].flags.map(
        (fl) => ({
          ...fl,
          generatorTermIndex: t,
        }),
      );
    }

    const balancedTerms = balanceTerms(shuffleTerms);

    setIsRoadmapChanged(true);
    setTerms(balancedTerms);
    setFlags(flags.filter((flag) => !allUniqueId.has(flag.id)));

    setIsRoadmapChanged(true);

    const cc = [
      balancedTerms.term1.flags,
      balancedTerms.term2.flags,
      balancedTerms.term3.flags,
      balancedTerms.term4.flags,
    ].map((el) => el.map((f) => f.id));

    setPrevTermsClone([].concat(...cc));
    return balancedTerms;
  };

  const insertAnswersFlagsToRoadmap_NEW_v0 = () => {
    console.log("generator base on UUID for new");

    // check array exists
    if (!Array.isArray(questionAnswers)) return;
    console.log({ flags });

    console.log({ questionAnswers, questionToFlags });
    const newTerms = structuredClone(terms);
    let finalTerms = [[], [], [], []];
    let mainFlags = [];

    // set terms title
    const titleNames = getMonthNames();
    newTerms.term1.title = titleNames.term1;
    newTerms.term2.title = titleNames.term2;
    newTerms.term3.title = titleNames.term3;
    newTerms.term4.title = titleNames.term4;
    console.log("placment", { tempFlagsPos, questionAnswers });

    questionAnswers.forEach((qa) => {
      let answerFlags = [];
      let questionAnswer = null;

      // questionToFlags.forEach((el) => {
      //   if (
      //     qa.answer_id &&
      //     `${el.epollAnswerId}` === `${qa.answer_id}` &&
      //     `${el.epollQuestionId}` === `${qa.id}`
      //   ) {
      //     answerFlags = el.flags;
      //     questionAnswers.forEach((question) => {
      //       if (
      //         `${el.epollAnswerId}` === `${question.answer_id}` &&
      //         `${el.epollQuestionId}` === `${question.id}`
      //       ) {
      //         questionAnswer = question;
      //       }
      //     });
      //   }
      // });

      // answerFlags = tempFlagsPos
      //   .filter(
      //     (el) =>
      //       qa.answer_id &&
      //       `${el.answer_id}` === `${qa.answer_id}` &&
      //       `${el.id}` === `${qa.id}`
      //   )
      //   .map(({ flagId }) => flagId);

      const abc = tempFlagsPos.filter(
        (el) =>
          qa.answer_id &&
          `${el.answer_id}` === `${qa.answer_id}` &&
          `${el.id}` === `${qa.id}`,
      );
      answerFlags = abc.map(({ flagId }) => flagId);

      // questionAnswer = { ...qa, relatedQuestions: [qa] };
      questionAnswer = qa;

      const addedFlags = [];
      if (Array.isArray(answerFlags)) {
        flags.forEach((flag) => {
          answerFlags.forEach((id) => {
            if (`${flag.id}` === `${id}`) {
              addedFlags.push({
                ...flag,
                autoGenerated: questionAnswer,
                addedUser: operatorData,
                addedDate: new Date(),
              });
            }
          });
        });
      }
      console.log({ addedFlags, answerFlags, flags });

      const uniqueIds = [];
      const unique = addedFlags?.filter((element) => {
        if (!uniqueIds.includes(element.id)) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
      mainFlags.push(...unique);
    });

    const uniqueMainId = new Set();
    mainFlags = mainFlags.filter(({ id }) => {
      if (uniqueMainId.has(id)) return false;
      uniqueMainId.add(id);
      return true;
    });
    console.log({ mainFlags });
    mainFlags = ignoreFlagsFromGenerator(mainFlags);

    // all flags -> main + all pre + all post
    let allFlags = [...mainFlags];
    let current = [...mainFlags];
    for (let index = 0; index < 100; index++) {
      const tempFF = [];
      current.forEach((flag) => {
        const post = flag?.postConditionFlags?.map((el) =>
          findFlagRef(el, flags),
        );
        const pre = flag?.preConditionFlags?.map((el) =>
          findFlagRef(el, flags),
        );

        const temp = [...post, ...pre].filter(
          (ac) => !allFlags?.find((obj) => obj?.id === ac?.id),
        );

        allFlags.push(...temp);
        tempFF.push(...temp);
      });

      if (tempFF.length === 0) break;
      current = tempFF;
    }

    allFlags = ignoreFlagsFromGenerator(allFlags);

    const nonMainFlags = allFlags.filter(
      ({ id }) => !mainFlags.find((el) => el.id === id),
    );

    const flagsReport = allFlags.map((fl, index, clone) => {
      const pre = clone.filter((c) =>
        c.preConditionFlags.find(({ id }) => id === fl.id),
      );
      const post = clone.filter((c) =>
        c.postConditionFlags.find(({ id }) => id === fl.id),
      );

      return {
        ...findFlagRef(fl, flags),
        index,
        post,
        pre,
      };
    });

    // just include pre that are in Main level
    let mainFlagsWithMinorPre = mainFlags.map((flag, _, clone) => {
      const preOfOther = clone.filter((fl) =>
        fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [...preOfOther, ...flag.preConditionFlags].filter(
          ({ id }) => clone.find((val) => val.id === id),
        ),
      };
    });

    // just include pre that are in non-Main level
    let nonMainFlagsWithMinorPre = nonMainFlags.map((flag) => {
      const preOfOther = allFlags.filter((fl) =>
        fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [...preOfOther, ...flag.preConditionFlags].filter(
          ({ id }) => allFlags.find((val) => val.id === id),
        ),
      };
    });

    // just include post that are in non-Main level
    let nonMainFlagsWithMinorPost = nonMainFlags.map((flag) => {
      const postOfOther = allFlags.filter((fl) =>
        fl.preConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [
          ...postOfOther,
          ...flag.postConditionFlags.filter(({ id }) =>
            allFlags.find((val) => val.id === id),
          ),
        ],
        preConditionFlags: [],
      };
    });

    // sort main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = mainFlagsWithMinorPre.find((fl) => {
        const preFlags = fl.preConditionFlags.map(({ id }) => id);
        // are flags rendered
        return isAllFlagsAddedToTerms(preFlags, finalTerms);
      });

      if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };

      // check manual placement
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = [];
      for (const qa of relatedQuestionsForTermIndex) {
        const tempoIndex = termIndexFinderForGenerator(
          qa?.id,
          targetFlag.id,
          qa?.answer_id,
        );

        if (tempoIndex) tempTermIndex.push(tempoIndex);
      }
      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      console.log({
        targetFlag,
        relatedQuestionsForTermIndex,
        isManualExists,
        tempTermIndex,
        manualTermIndex,
      });

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }

      const conditions = findTermAndIndexOfPreOfFlag(targetFlag, finalTerms);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.max(...conditions.map((val) => val.termIndex));
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const cc = conditions
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        if (cc.length !== 0) {
          tempFlagIndex = Math.max(...cc);
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      } else {
        placement.termIndex = isManualExists ? manualTermIndex : 2;
      }

      console.log("main flags", {
        targetFlag,
        conditions,
        isManualExists,
        manualTermIndex,
        placement,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlagsWithMinorPre = mainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    // sort non-main flags -> base on pre
    console.log({ nonMainFlagsWithMinorPre });
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = nonMainFlagsWithMinorPre.find((fl) => {
        const preFlags = fl.preConditionFlags.map(({ id }) => id);
        if (preFlags.length === 0) return false;
        // are flags rendered
        return isOneOfFlagsAddedToTerms(preFlags, finalTerms);
        // return isAllFlagsAddedToTerms(preFlags, finalTerms);
      });

      if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 0, flagIndex: 0 };
      const conditions = findTermAndIndexOfPreOfFlag(targetFlag, finalTerms);
      const cond2 = findTermAndIndexOfPreOfFlagBaseOnMainFlag(
        targetFlag,
        finalTerms,
      );
      const con3 = conditions.length !== 0;
      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        const tempTermIndex = Math.max(
          ...conditions.map((val) => val.termIndex),
        );
        // find max of flagIndex from preConditions
        const tempFlagIndex = Math.max(
          ...conditions
            .filter((c) => c.termIndex === tempTermIndex)
            .map((val) => val.flagIndex),
        );

        placement.termIndex = tempTermIndex;
        placement.flagIndex = tempFlagIndex;
      }

      if (cond2.length !== 0) {
        // find min of termIndex from preConditions
        const tempTermIndex2 = Math.min(...cond2.map((val) => val.termIndex));
        // find max of flagIndex from preConditions
        const tempFlagIndex2 = Math.min(
          ...cond2
            .filter((c) => c.termIndex === tempTermIndex2)
            .map((val) => val.flagIndex),
        );

        if (con3) {
          if (
            placement.termIndex > tempTermIndex2 ||
            (placement.termIndex === tempTermIndex2 &&
              placement.flagIndex > tempFlagIndex2)
          ) {
            message.error(`${targetFlag.title} خطا در کارت`);
          }
        }
        placement.termIndex = tempTermIndex2;
        placement.flagIndex = tempFlagIndex2 - 1;
      }

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      console.log("non-main flags 01 - pre", {
        targetFlag,
        conditions,
        placement,
      });

      // remove from mainFlagsWithMinorPre
      nonMainFlagsWithMinorPre = nonMainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    // filter non-main flags with post relation that not exists in rendered list
    nonMainFlagsWithMinorPost = nonMainFlagsWithMinorPost.filter(
      ({ id }) => !finalTerms.find((term) => term.find((fl) => fl.id === id)),
    );

    // sort non-main flags -> base on post
    console.log({ nonMainFlagsWithMinorPost });
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = nonMainFlagsWithMinorPost.find((fl) => {
        const postFlags = fl.postConditionFlags.map(({ id }) => id);
        if (postFlags.length === 0) return false;
        // check is one flag rendered
        // return isOneOfFlagsAddedToTerms(postFlags, finalTerms);
        return isAllFlagsAddedToTerms(postFlags, finalTerms);
      });

      if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 0, flagIndex: 0 };
      const conditions = findTermAndIndexOfPostOfFlag(targetFlag, finalTerms);
      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        const tempTermIndex = Math.min(
          ...conditions.map((val) => val.termIndex),
        );
        // find max of flagIndex from preConditions
        const tempFlagIndex = Math.min(
          ...conditions
            .filter((c) => c.termIndex === tempTermIndex)
            .map((val) => val.flagIndex),
        );

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      }

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex - 1,
        terms: finalTerms,
      });

      console.log("non-main flags 02 - post", {
        targetFlag,
        conditions,
        placement,
      });

      // remove from mainFlagsWithMinorPostPre
      nonMainFlagsWithMinorPost = nonMainFlagsWithMinorPost.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    const allUniqueId = new Set(allFlags.map(({ id }) => id));
    const allMainUniqueId = new Set(mainFlags.map(({ id }) => id));

    for (let index = 0; index < finalTerms.length; index++) {
      finalTerms[index] = finalTerms[index].map((flag, i) => {
        const isMainFlag = allMainUniqueId.has(flag.id);

        const flagRef = findFlagRef({ id: flag.id }, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);

        if (!isMainFlag) {
          // find all post
          return {
            ...flagRef,
            report: {
              post: fReport?.post?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null,
              ),
              pre: fReport.pre?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null,
              ),
            },
            addedDate: new Date(),
            addedUser: operatorData,
            autoGenerated: {},
          };
        }

        const relatedQuestions = tempFlagsPos
          .filter((el) => el.flagId === flagRef.id)
          .filter((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.id}` &&
                `${qa.answer_id}` === `${a.answer_id}`,
            );
          })
          .map((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.id}` &&
                `${qa.answer_id}` === `${a.answer_id}`,
            );
          })
          .filter((q) => q?.answer !== "" && q?.answer_id !== null);

        return {
          ...flag,
          addedDate: new Date(),
          addedUser: operatorData,
          postConditionFlags: flagRef.postConditionFlags,
          preConditionFlags: flagRef.preConditionFlags,
          report: {
            post: fReport.post?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null,
            ),
            pre: fReport.pre?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null,
            ),
          },
          autoGenerated: { ...flag.autoGenerated, relatedQuestions },
        };
      });
      newTerms[`term${index + 1}`].flags = finalTerms[index];
    }

    // sort other flags that have bug
    const conflictFlags = allFlags
      .filter(({ id }) => !allUniqueId.has(id))
      .map((flag) => {
        const finalFlag = findFlagRef(flag, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);
        return {
          ...finalFlag,
          addedDate: new Date(),
          addedUser: operatorData,
          report: { post: fReport.post, pre: fReport.pre },
          autoGenerated: { ...flag?.autoGenerated, conflict: true },
        };
      });
    newTerms[`term3`].flags = [...conflictFlags, ...newTerms[`term3`].flags];

    const shuffleTerms = shuffleSoloFlags(newTerms);

    // map termIndex to each
    for (let t = 0; t < 4; t++) {
      newTerms[`term${t + 1}`].flags = newTerms[`term${t + 1}`].flags.map(
        (fl) => ({
          ...fl,
          generatorTermIndex: t,
        }),
      );
    }

    const balancedTerms = balanceTerms(shuffleTerms);

    setIsRoadmapChanged(true);
    setTerms(balancedTerms);
    setFlags(flags.filter((flag) => !allUniqueId.has(flag.id)));

    setIsRoadmapChanged(true);

    const cc = [
      balancedTerms.term1.flags,
      balancedTerms.term2.flags,
      balancedTerms.term3.flags,
      balancedTerms.term4.flags,
    ].map((el) => el.map((f) => f.id));

    setPrevTermsClone([].concat(...cc));
    return balancedTerms;
  };

  const insertAnswersFlagsToRoadmap_OLDـV1 = () => {
    console.log("generator lunched - epoll version");

    // check array exists
    if (!Array.isArray(questionAnswers)) return;

    console.log({ questionAnswers });
    const newTerms = structuredClone(terms);
    let finalTerms = [[], [], [], []];
    let mainFlags = [];

    // set terms title
    const titleNames = getMonthNames();
    newTerms.term1.title = titleNames.term1;
    newTerms.term2.title = titleNames.term2;
    newTerms.term3.title = titleNames.term3;
    newTerms.term4.title = titleNames.term4;

    questionAnswers.forEach((qa) => {
      let answerFlags = [];
      let questionAnswer = null;

      questionToFlags.forEach((el) => {
        if (
          qa.answer_id &&
          `${el.epollAnswerId}` === `${qa.answer_id}` &&
          `${el.epollQuestionId}` === `${qa.id}`
        ) {
          answerFlags = el.flags;
          questionAnswers.forEach((question) => {
            if (
              `${el.epollAnswerId}` === `${question.answer_id}` &&
              `${el.epollQuestionId}` === `${question.id}`
            ) {
              questionAnswer = question;
            }
          });
        }
      });

      const addedFlags = [];
      if (Array.isArray(answerFlags)) {
        flags.forEach((flag) => {
          answerFlags.forEach((id) => {
            if (`${flag.id}` === `${id}`) {
              addedFlags.push({
                ...flag,
                autoGenerated: questionAnswer,
                addedUser: operatorData,
                addedDate: new Date(),
              });
            }
          });
        });
      }

      const uniqueIds = [];
      const unique = addedFlags?.filter((element) => {
        if (!uniqueIds.includes(element.id)) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
      mainFlags.push(...unique);
    });

    const uniqueMainId = new Set();
    mainFlags = mainFlags.filter(({ id }) => {
      if (uniqueMainId.has(id)) return false;
      uniqueMainId.add(id);
      return true;
    });

    mainFlags = ignoreFlagsFromGenerator(mainFlags);

    const hiddenFlags = [];
    for (const fl of mainFlags) {
      const postFlags = fl.postConditionFlags
        .map((el) => findFlagRef(el, flags))
        .filter((el) => el && el.hidden && !uniqueMainId.has(el.id));

      const preFlags = fl.preConditionFlags
        .map((el) => findFlagRef(el, flags))
        .filter((el) => el && el.hidden && !uniqueMainId.has(el.id));

      const tempoFlagsList = [...postFlags, ...preFlags].map((flag) => ({
        ...flag,
        addedUser: operatorData,
        addedDate: new Date(),
      }));

      for (const addEl of tempoFlagsList) {
        if (hiddenFlags.find((flg) => flg.id === addEl.id)) continue;
        hiddenFlags.push(addEl);
      }
    }

    const flagsReport = mainFlags.map((fl, index, clone) => {
      const pre = [...mainFlags, ...clone].filter((c) =>
        c.preConditionFlags.find(({ id }) => id === fl.id),
      );
      const post = [...mainFlags, ...clone].filter((c) =>
        c.postConditionFlags.find(({ id }) => id === fl.id),
      );

      return {
        ...findFlagRef(fl, flags),
        index,
        post,
        pre,
      };
    });

    const hiddenFlagsReport = hiddenFlags.map((fl, index) => {
      const pre = mainFlags.filter((c) =>
        c.preConditionFlags.find(({ id }) => id === fl.id),
      );
      const post = mainFlags.filter((c) =>
        c.postConditionFlags.find(({ id }) => id === fl.id),
      );

      return {
        ...findFlagRef(fl, flags),
        index,
        post,
        pre,
      };
    });

    // just include pre that are in Main level
    let mainFlagsWithMinorPre = mainFlags.map((flag, _, clone) => {
      const preOfOther = clone.filter((fl) =>
        fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [...preOfOther, ...flag.preConditionFlags].filter(
          ({ id }) => clone.find((val) => val.id === id),
        ),
      };
    });

    // sort main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = mainFlagsWithMinorPre.find((fl) => {
        const preFlags = fl.preConditionFlags.map(({ id }) => id);
        // are flags rendered
        return isAllFlagsAddedToTerms(preFlags, finalTerms);
      });

      if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };
      console.log({ targetFlag, placement });
      // check manual placement
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = [];
      for (const qa of relatedQuestionsForTermIndex) {
        const tempoIndex = termIndexFinderForGenerator(
          qa?.id,
          targetFlag.id,
          qa?.answer_id,
        );

        if (tempoIndex) tempTermIndex.push(tempoIndex);
      }
      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      console.log({
        targetFlag,
        relatedQuestionsForTermIndex,
        isManualExists,
        tempTermIndex,
        manualTermIndex,
      });

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }

      const conditions = findTermAndIndexOfPreOfFlag(targetFlag, finalTerms);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.max(...conditions.map((val) => val.termIndex));
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const cc = conditions
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        if (cc.length !== 0) {
          tempFlagIndex = Math.max(...cc) - 1;
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      } else {
        placement.termIndex = isManualExists ? manualTermIndex : 2;
      }

      console.log("main flags", {
        targetFlag,
        conditions,
        isManualExists,
        manualTermIndex,
        placement,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlagsWithMinorPre = mainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    // sort hidden flags
    for (const targetFlag of hiddenFlags) {
      const conditions = findTermAndIndexOfPreOfHiddenFlagBaseOnMainFlag(
        targetFlag,
        finalTerms,
        flags,
      );

      const termIndex = Math.min(...conditions.map((val) => val.termIndex));
      const flagIndex = Math.min(
        ...conditions
          .filter((e) => e.termIndex === termIndex)
          .map((val) => val.flagIndex),
      );
      console.log({ hiddenFlag: targetFlag, conditions, termIndex, flagIndex });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: conditions.length === 0 ? 0 : termIndex,
        colIndex: conditions.length === 0 ? 0 : flagIndex - 1,
        terms: finalTerms,
      });
    }

    for (let index = 0; index < finalTerms.length; index++) {
      finalTerms[index] = finalTerms[index].map((flag, i) => {
        const isMainFlag = uniqueMainId.has(flag.id);

        const flagRef = findFlagRef({ id: flag.id }, flags);
        const fReport = (
          uniqueMainId.has(flagRef.id) ? flagsReport : hiddenFlagsReport
        ).find(({ id }) => id === flag.id);

        if (!isMainFlag) {
          // find all post
          return {
            ...flagRef,
            report: {
              post: fReport?.post?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  uniqueMainId.has(el.id),
              ),
              pre: fReport.pre?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  uniqueMainId.has(el.id),
              ),
            },
            postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
              uniqueMainId.has(id),
            ),
            preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
              uniqueMainId.has(id),
            ),
            addedDate: new Date(),
            addedUser: operatorData,
            // autoGenerated: {},
          };
        }

        const relatedQuestions = questionToFlags
          .filter((val) => val.flags.includes(flagRef.id))
          .filter((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.epollQuestionId}` &&
                `${qa.answer_id}` === `${a.epollAnswerId}`,
            );
          })
          .map((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.epollQuestionId}` &&
                `${qa.answer_id}` === `${a.epollAnswerId}`,
            );
          })
          .filter((q) => q?.answer !== "" && q?.answer_id !== null);

        return {
          ...flag,
          addedDate: new Date(),
          addedUser: operatorData,
          postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          report: {
            post: fReport.post?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                uniqueMainId.has(el.id),
            ),
            pre: fReport.pre?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                uniqueMainId.has(el.id),
            ),
          },
          autoGenerated: { ...flag.autoGenerated, relatedQuestions },
        };
      });
      newTerms[`term${index + 1}`].flags = finalTerms[index];
    }

    // sort other flags that have bug
    const conflictFlags = mainFlags
      .filter(({ id }) => !uniqueMainId.has(id))
      .map((flag) => {
        const finalFlag = findFlagRef(flag, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);
        return {
          ...finalFlag,
          addedDate: new Date(),
          addedUser: operatorData,
          report: {
            post: fReport.post.filter((e) => uniqueMainId.has(e.id)),
            pre: fReport.pre.filter((e) => uniqueMainId.has(e.id)),
          },
          autoGenerated: { ...flag?.autoGenerated, conflict: true },
          postConditionFlags: finalFlag.postConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          preConditionFlags: finalFlag.preConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
        };
      });
    newTerms[`term3`].flags = [...conflictFlags, ...newTerms[`term3`].flags];

    const shuffleTerms = shuffleSoloFlags(newTerms);
    const balancedTerms = balanceTerms(shuffleTerms);

    setIsRoadmapChanged(true);
    setTerms(balancedTerms);
    setFlags(getUnusedFlags(balancedTerms, flags));

    setIsRoadmapChanged(true);

    setPrevTermsClone(
      [].concat(
        ...[
          balancedTerms.term1.flags,
          balancedTerms.term2.flags,
          balancedTerms.term3.flags,
          balancedTerms.term4.flags,
        ].map((el) => el.map((f) => f.id)),
      ),
    );
    return balancedTerms;
  };

  const insertAnswersFlagsToRoadmap_OLD_V2 = () => {
    console.log("generator lunched -- epoll version");

    // check array exists
    if (!Array.isArray(questionAnswers)) return;

    console.log({ questionAnswers });
    const newTerms = structuredClone(terms);
    let finalTerms = [[], [], [], []];
    let mainFlags = [];

    // set terms title
    const titleNames = getMonthNames();
    newTerms.term1.title = titleNames.term1;
    newTerms.term2.title = titleNames.term2;
    newTerms.term3.title = titleNames.term3;
    newTerms.term4.title = titleNames.term4;

    questionAnswers.forEach((qa) => {
      let answerFlags = [];
      let questionAnswer = null;

      questionToFlags.forEach((el) => {
        if (
          qa.answer_id &&
          `${el.epollAnswerId}` === `${qa.answer_id}` &&
          `${el.epollQuestionId}` === `${qa.id}`
        ) {
          answerFlags = el.flags;
          questionAnswers.forEach((question) => {
            if (
              `${el.epollAnswerId}` === `${question.answer_id}` &&
              `${el.epollQuestionId}` === `${question.id}`
            ) {
              questionAnswer = question;
            }
          });
        }
      });

      const addedFlags = [];
      if (Array.isArray(answerFlags)) {
        flags.forEach((flag) => {
          answerFlags.forEach((id) => {
            if (`${flag.id}` === `${id}`) {
              addedFlags.push({
                ...flag,
                autoGenerated: questionAnswer,
                addedUser: operatorData,
                addedDate: new Date(),
              });
            }
          });
        });
      }

      const uniqueIds = [];
      const unique = addedFlags?.filter((element) => {
        if (!uniqueIds.includes(element.id)) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
      mainFlags.push(...unique);
    });

    const uniqueMainId = new Set();
    mainFlags = mainFlags.filter(({ id }) => {
      if (uniqueMainId.has(id)) return false;
      uniqueMainId.add(id);
      return true;
    });

    mainFlags = ignoreFlagsFromGenerator(mainFlags);

    const flagsReport = mainFlags.map((fl, index, clone) => {
      const pre = clone.filter((c) =>
        c.preConditionFlags.find(({ id }) => id === fl.id),
      );
      const post = clone.filter((c) =>
        c.postConditionFlags.find(({ id }) => id === fl.id),
      );

      return {
        ...findFlagRef(fl, flags),
        index,
        post,
        pre,
      };
    });
    console.log({ flagsReport, mainFlags });

    // just include pre that are in Main level
    let mainFlagsWithMinorPre = mainFlags.map((flag, _, clone) => {
      const preOfOther = clone.filter((fl) =>
        fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [...preOfOther, ...flag.preConditionFlags].filter(
          ({ id }) => clone.find((val) => val.id === id),
        ),
      };
    });
    console.log({ mainFlagsWithMinorPre });

    // sort main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = mainFlagsWithMinorPre.find((fl) => {
        const flRep = flagsReport.find((e) => e.id === fl.id);
        if (fl.hidden) {
          return false;
          // console.log("hidden", { fl, uniqueMainId });
          // return !fl.preConditionFlags.some(({ id }) => uniqueMainId.has(id));
        }

        const allPreNonHiddenFlagIds = [...fl.preConditionFlags, ...flRep.post]
          .filter((el) => !findFlagRef(el, flags).hidden)
          .map((e) => e.id);

        console.log({ fl, allPreNonHiddenFlagIds });
        // are flags rendered
        return isAllFlagsAddedToTerms(allPreNonHiddenFlagIds, finalTerms);
      });

      if (!targetFlag) break;

      const flReport = flagsReport.find(({ id }) => id === targetFlag.id);

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };

      // check manual placement
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = [];
      for (const qa of relatedQuestionsForTermIndex) {
        const tempoIndex = termIndexFinderForGenerator(
          qa?.id,
          targetFlag.id,
          qa?.answer_id,
        );

        if (tempoIndex) tempTermIndex.push(tempoIndex);
      }
      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }

      // const conditions = findTermAndIndexOfPreOfFlag(targetFlag, finalTerms);
      const conditions = flReport.pre
        .map((fl) => findFlagPositionFromArrayTerms(fl.id, finalTerms))
        .filter((e) => e);

      const conditionsPost = flReport.post
        .map((fl) => findFlagPositionFromArrayTerms(fl.id, finalTerms))
        .filter((e) => e);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.max(...conditions.map((val) => val.termIndex));
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const cc = conditions
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        if (cc.length !== 0) {
          tempFlagIndex = Math.max(...cc);
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      } else {
        placement.termIndex = isManualExists ? manualTermIndex : 2;
      }
      if (conditionsPost.length !== 0) {
        // find min of termIndex from post
        let tempTermIndex = Math.max(
          ...conditionsPost.map((val) => val.termIndex),
        );
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const cc = conditionsPost
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        if (cc.length !== 0) {
          tempFlagIndex = Math.max(...cc);
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      }

      console.log(targetFlag.title, {
        targetFlag,
        relatedQuestionsForTermIndex,
        isManualExists,
        tempTermIndex,
        manualTermIndex,
        conditions,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlagsWithMinorPre = mainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    console.warn(
      "-------- sort hidden flags v10 --------",
      mainFlagsWithMinorPre.map((e) => ({
        ...e,
        report: flagsReport.find(({ id }) => id === e.id),
      })),
    );
    // sort hidden flags
    // for (let index = 0; index < 1000; index++) {
    for (const targetFlag of mainFlagsWithMinorPre) {
      // // get one flag
      // // eslint-disable-next-line no-loop-func
      // const targetFlag = mainFlagsWithMinorPre.find((fl) => {
      //   // are flags rendered
      //   return (
      //     isAllFlagsAddedToTerms(fl.preConditionFlags, finalTerms) && fl.hidden
      //   );
      // });

      // if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };
      const flReport = flagsReport.find((el) => el.id === targetFlag.id);

      // check manual placement
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = relatedQuestionsForTermIndex
        .map((qa) =>
          termIndexFinderForGenerator(qa?.id, targetFlag.id, qa?.answer_id),
        )
        .filter((e) => e);

      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }
      placement.termIndex = isManualExists ? manualTermIndex : 2;

      const conditions = flReport.pre
        .map((fl) => findFlagPositionFromArrayTerms(fl.id, finalTerms))
        .filter((e) => e);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.min(...conditions.map((val) => val.termIndex));
        let tempFlagIndex =
          Math.min(
            ...conditions
              .filter((c) => c.termIndex === tempTermIndex)
              .map((val) => val.flagIndex),
          ) - 1;

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      }

      console.log("hidden flag", targetFlag.title, {
        targetFlag,
        conditions,
        isManualExists,
        manualTermIndex,
        tempTermIndex,
        placement,
        relatedQuestionsForTermIndex,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlagsWithMinorPre = mainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    for (let index = 0; index < finalTerms.length; index++) {
      finalTerms[index] = finalTerms[index].map((flag, i) => {
        const isMainFlag = uniqueMainId.has(flag.id);

        const flagRef = findFlagRef({ id: flag.id }, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);

        if (!isMainFlag) {
          // find all post
          return {
            ...flagRef,
            report: {
              post: fReport?.post?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  uniqueMainId.has(el.id),
              ),
              pre: fReport.pre?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  uniqueMainId.has(el.id),
              ),
            },
            postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
              uniqueMainId.has(id),
            ),
            preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
              uniqueMainId.has(id),
            ),
            addedDate: new Date(),
            addedUser: operatorData,
            // autoGenerated: {},
          };
        }

        const relatedQuestions = questionToFlags
          .filter((val) => val.flags.includes(flagRef.id))
          .filter((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.epollQuestionId}` &&
                `${qa.answer_id}` === `${a.epollAnswerId}`,
            );
          })
          .map((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.epollQuestionId}` &&
                `${qa.answer_id}` === `${a.epollAnswerId}`,
            );
          })
          .filter((q) => q?.answer !== "" && q?.answer_id !== null);

        return {
          ...flag,
          addedDate: new Date(),
          addedUser: operatorData,
          postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          report: {
            post: fReport.post?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                uniqueMainId.has(el.id),
            ),
            pre: fReport.pre?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                uniqueMainId.has(el.id),
            ),
          },
          autoGenerated: { ...flag.autoGenerated, relatedQuestions },
        };
      });
      newTerms[`term${index + 1}`].flags = finalTerms[index];
    }

    // sort other flags that have bug
    const conflictFlags = mainFlags
      .filter(({ id }) => !uniqueMainId.has(id))
      .map((flag) => {
        const finalFlag = findFlagRef(flag, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);
        return {
          ...finalFlag,
          addedDate: new Date(),
          addedUser: operatorData,
          report: {
            post: fReport.post.filter((e) => uniqueMainId.has(e.id)),
            pre: fReport.pre.filter((e) => uniqueMainId.has(e.id)),
          },
          autoGenerated: { ...flag?.autoGenerated, conflict: true },
          postConditionFlags: finalFlag.postConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          preConditionFlags: finalFlag.preConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
        };
      });
    newTerms[`term3`].flags = [...conflictFlags, ...newTerms[`term3`].flags];

    const shuffleTerms = shuffleSoloFlags(newTerms);
    const balancedTerms = balanceTerms(shuffleTerms);

    setIsRoadmapChanged(true);
    setTerms(balancedTerms);
    setFlags(getUnusedFlags(balancedTerms, flags));

    setIsRoadmapChanged(true);

    setPrevTermsClone(
      [].concat(
        ...[
          balancedTerms.term1.flags,
          balancedTerms.term2.flags,
          balancedTerms.term3.flags,
          balancedTerms.term4.flags,
        ].map((el) => el.map((f) => f.id)),
      ),
    );
    return balancedTerms;
  };

  const insertAnswersFlagsToRoadmap_OLD = () => {
    console.log("generator lunched -- epoll version");

    // check array exists
    if (!Array.isArray(questionAnswers)) return;

    console.log({ questionAnswers });
    const newTerms = structuredClone(terms);
    let finalTerms = [[], [], [], []];
    let mainFlags = [];

    // set terms title
    const titleNames = getMonthNames();
    newTerms.term1.title = titleNames.term1;
    newTerms.term2.title = titleNames.term2;
    newTerms.term3.title = titleNames.term3;
    newTerms.term4.title = titleNames.term4;

    questionAnswers.forEach((qa) => {
      let answerFlags = [];
      let questionAnswer = null;

      questionToFlags.forEach((el) => {
        if (
          qa.answer_id &&
          `${el.epollAnswerId}` === `${qa.answer_id}` &&
          `${el.epollQuestionId}` === `${qa.id}`
        ) {
          answerFlags = el.flags;
          questionAnswers.forEach((question) => {
            if (
              `${el.epollAnswerId}` === `${question.answer_id}` &&
              `${el.epollQuestionId}` === `${question.id}`
            ) {
              questionAnswer = question;
            }
          });
        }
      });

      const addedFlags = [];
      if (Array.isArray(answerFlags)) {
        flags.forEach((flag) => {
          answerFlags.forEach((id) => {
            if (`${flag.id}` === `${id}`) {
              addedFlags.push({
                ...flag,
                autoGenerated: questionAnswer,
                addedUser: operatorData,
                addedDate: new Date(),
              });
            }
          });
        });
      }

      const uniqueIds = [];
      const unique = addedFlags?.filter((element) => {
        if (!uniqueIds.includes(element.id)) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
      mainFlags.push(...unique);
    });

    const uniqueMainId = new Set();
    mainFlags = mainFlags.filter(({ id }) => {
      if (uniqueMainId.has(id)) return false;
      uniqueMainId.add(id);
      return true;
    });
    mainFlags = ignoreFlagsFromGenerator(mainFlags);

    const flagsReport = mainFlags.map((fl, index, clone) => {
      const shouldBeBeforeMeIds = clone
        .map((e) => findFlagRef(e, flags))
        .filter((c) => c.postConditionFlags.find(({ id }) => id === fl.id))
        .map((e) => e.id);

      const shouldBeAfterMeIds = clone
        .map((e) => findFlagRef(e, flags))
        .filter((c) => c.preConditionFlags.find(({ id }) => id === fl.id))
        .map((e) => e.id);

      return {
        ...findFlagRef(fl, flags),
        index,
        shouldBeAfterMeIds: [
          ...shouldBeAfterMeIds,
          ...fl.postConditionFlags.map((e) => e.id),
        ],
        shouldBeBeforeMeIds: [
          ...fl.preConditionFlags.map((e) => e.id),
          ...shouldBeBeforeMeIds,
        ],
      };
    });
    console.log({ flagsReport, mainFlags });

    // sort main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // eslint-disable-next-line no-loop-func
      const targetFlag = mainFlags
        .filter((e) => !e.hidden)
        // eslint-disable-next-line no-loop-func
        .find((fl) => {
          const flReport = flagsReport.find((e) => e.id === fl.id);
          const allPreNonHiddenFlagIds = flReport.shouldBeBeforeMeIds
            .filter((id) => !findFlagRef({ id }, flags).hidden)
            .filter((e) => uniqueMainId.has(e));

          // are flags rendered

          return isAllFlagsAddedToTerms(allPreNonHiddenFlagIds, finalTerms);
        });

      if (!targetFlag) break;

      const flReport = flagsReport.find(({ id }) => id === targetFlag.id);

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };

      // check manual placement -----------------
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = relatedQuestionsForTermIndex
        .map((qa) =>
          termIndexFinderForGenerator(qa?.id, targetFlag.id, qa?.answer_id),
        )
        .filter((e) => e);

      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }
      // ------------ check manual placement

      const conditions = flReport.shouldBeBeforeMeIds
        .map((id) => findFlagPositionFromArrayTerms(id, finalTerms))
        .filter((e) => e);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.max(...conditions.map((val) => val.termIndex));
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const flagIndexArr = conditions
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        if (flagIndexArr.length !== 0) {
          tempFlagIndex = Math.max(...flagIndexArr);
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      } else {
        placement.termIndex = isManualExists ? manualTermIndex : 2;
      }

      console.log(targetFlag.title, {
        targetFlag,
        flReport,
        relatedQuestionsForTermIndex,
        isManualExists,
        tempTermIndex,
        manualTermIndex,
        conditions,
        placement,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlags = mainFlags.filter(({ id }) => id !== targetFlag.id);
    }

    console.warn(
      "-------- sort hidden flags v10 --------",
      mainFlags.map((e) => ({
        ...e,
        report: flagsReport.find(({ id }) => id === e.id),
      })),
    );
    // sort hidden flags
    for (const targetFlag of mainFlags) {
      // break;
      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };
      const flReport = flagsReport.find((el) => el.id === targetFlag.id);

      // check manual placement -------------
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = relatedQuestionsForTermIndex
        .map((qa) =>
          termIndexFinderForGenerator(qa?.id, targetFlag.id, qa?.answer_id),
        )
        .filter((e) => e);

      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }
      placement.termIndex = isManualExists ? manualTermIndex : 2;

      // ------------- check manual placement END -------------
      const conditions = flReport.shouldBeAfterMeIds
        .map((id) => findFlagPositionFromArrayTerms(id, finalTerms))
        .filter((e) => e);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        placement.termIndex = Math.min(
          ...conditions.map((val) => val.termIndex),
        );
        placement.flagIndex =
          Math.min(
            ...conditions
              .filter((c) => c.termIndex === placement.termIndex)
              .map((val) => val.flagIndex),
          ) - 1;
      }
      const conditionsSecond = flReport.shouldBeBeforeMeIds
        .map((id) => findFlagPositionFromArrayTerms(id, finalTerms))
        .filter((e) => e);

      if (conditionsSecond.length !== 0) {
        // find min of termIndex from preConditions
        const secondTermIndex = Math.max(
          ...conditionsSecond.map((val) => val.termIndex),
        );
        const secondFlagIndex = Math.max(
          ...conditionsSecond
            .filter((c) => c.termIndex === placement.termIndex)
            .map((val) => val.flagIndex),
        );
      }

      console.log("hidden flag", targetFlag.title, {
        targetFlag,
        conditions,
        isManualExists,
        manualTermIndex,
        placement,
        relatedQuestionsForTermIndex,
        flReport,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlags = mainFlags.filter(({ id }) => id !== targetFlag.id);
    }

    for (let index = 0; index < finalTerms.length; index++) {
      finalTerms[index] = finalTerms[index].map((flag, i) => {
        const isMainFlag = uniqueMainId.has(flag.id);

        const flagRef = findFlagRef({ id: flag.id }, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);

        if (!isMainFlag) {
          // find all post
          return {
            ...flagRef,
            report: {
              post: fReport?.post?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  uniqueMainId.has(el.id),
              ),
              pre: fReport.pre?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  uniqueMainId.has(el.id),
              ),
            },
            postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
              uniqueMainId.has(id),
            ),
            preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
              uniqueMainId.has(id),
            ),
            addedDate: new Date(),
            addedUser: operatorData,
            // autoGenerated: {},
          };
        }

        const relatedQuestions = questionToFlags
          .filter((val) => val.flags.includes(flagRef.id))
          .filter((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.epollQuestionId}` &&
                `${qa.answer_id}` === `${a.epollAnswerId}`,
            );
          })
          .map((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.epollQuestionId}` &&
                `${qa.answer_id}` === `${a.epollAnswerId}`,
            );
          })
          .filter((q) => q?.answer !== "" && q?.answer_id !== null);

        return {
          ...flag,
          addedDate: new Date(),
          addedUser: operatorData,
          postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          report: {
            post: fReport.post?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                uniqueMainId.has(el.id),
            ),
            pre: fReport.pre?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                uniqueMainId.has(el.id),
            ),
          },
          autoGenerated: { ...flag.autoGenerated, relatedQuestions },
        };
      });
      newTerms[`term${index + 1}`].flags = finalTerms[index];
    }

    // sort other flags that have bug
    const conflictFlags = mainFlags
      .filter(({ id }) => !uniqueMainId.has(id))
      .map((flag) => {
        const finalFlag = findFlagRef(flag, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);
        return {
          ...finalFlag,
          addedDate: new Date(),
          addedUser: operatorData,
          report: {
            post: fReport.post.filter((e) => uniqueMainId.has(e.id)),
            pre: fReport.pre.filter((e) => uniqueMainId.has(e.id)),
          },
          autoGenerated: { ...flag?.autoGenerated, conflict: true },
          postConditionFlags: finalFlag.postConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          preConditionFlags: finalFlag.preConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
        };
      });
    newTerms[`term3`].flags = [...conflictFlags, ...newTerms[`term3`].flags];

    const shuffleTerms = shuffleSoloFlags(newTerms);
    const balancedTerms = balanceTerms(shuffleTerms);
    for (let t = 0; t < 4; t++) {
      balancedTerms[`term${t + 1}`].flags = balancedTerms[`term${t + 1}`].flags.map(
        (fl) => ({ ...fl, generatorTermIndex: t }),
      );
    }
    // const balancedTerms = newTerms;
    setIsRoadmapChanged(true);
    setTerms(balancedTerms);
    setFlags(getUnusedFlags(balancedTerms, flags));

    setIsRoadmapChanged(true);

    setPrevTermsClone(
      [].concat(
        ...[
          balancedTerms.term1.flags,
          balancedTerms.term2.flags,
          balancedTerms.term3.flags,
          balancedTerms.term4.flags,
        ].map((el) => el.map((f) => f.id)),
      ),
    );
    return balancedTerms;
  };

  const insertAnswersFlagsToRoadmap_NEW_v3 = () => {
    console.log("generator base on UUID for new");

    // check array exists
    if (!Array.isArray(questionAnswers)) return;

    console.log({ questionAnswers, questionToFlags });
    const newTerms = structuredClone(terms);
    let finalTerms = [[], [], [], []];
    let mainFlags = [];

    // set terms title
    const titleNames = getMonthNames();
    newTerms.term1.title = titleNames.term1;
    newTerms.term2.title = titleNames.term2;
    newTerms.term3.title = titleNames.term3;
    newTerms.term4.title = titleNames.term4;

    questionAnswers.forEach((qa) => {
      let answerFlags = [];
      let questionAnswer = null;

      // questionToFlags.forEach((el) => {
      //   if (
      //     qa.answer_id &&
      //     `${el.epollAnswerId}` === `${qa.answer_id}` &&
      //     `${el.epollQuestionId}` === `${qa.id}`
      //   ) {
      //     answerFlags = el.flags;
      //     questionAnswers.forEach((question) => {
      //       if (
      //         `${el.epollAnswerId}` === `${question.answer_id}` &&
      //         `${el.epollQuestionId}` === `${question.id}`
      //       ) {
      //         questionAnswer = question;
      //       }
      //     });
      //   }
      // });

      // answerFlags = tempFlagsPos
      //   .filter(
      //     (el) =>
      //       qa.answer_id &&
      //       `${el.answer_id}` === `${qa.answer_id}` &&
      //       `${el.id}` === `${qa.id}`
      //   )
      //   .map(({ flagId }) => flagId);

      const abc = tempFlagsPos.filter(
        (el) =>
          qa.answer_id &&
          `${el.answer_id}` === `${qa.answer_id}` &&
          `${el.id}` === `${qa.id}`,
      );
      answerFlags = abc.map(({ flagId }) => flagId);

      // questionAnswer = { ...qa, relatedQuestions: [qa] };
      questionAnswer = qa;

      const addedFlags = [];
      if (Array.isArray(answerFlags)) {
        flags.forEach((flag) => {
          answerFlags.forEach((id) => {
            if (`${flag.id}` === `${id}`) {
              addedFlags.push({
                ...flag,
                autoGenerated: questionAnswer,
                addedUser: operatorData,
                addedDate: new Date(),
              });
            }
          });
        });
      }
      console.log({ addedFlags, answerFlags, flags });

      const uniqueIds = [];
      const unique = addedFlags?.filter((element) => {
        if (!uniqueIds.includes(element.id)) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
      mainFlags.push(...unique);
    });

    console.log({ mainFlags });

    const uniqueMainId = new Set();
    mainFlags = mainFlags.filter(({ id }) => {
      if (uniqueMainId.has(id)) return false;
      uniqueMainId.add(id);
      return true;
    });
    mainFlags = ignoreFlagsFromGenerator(mainFlags);

    const hiddenFlags = [];
    for (const fl of mainFlags) {
      const postFlags = fl.postConditionFlags
        .map((el) => findFlagRef(el, flags))
        .filter((el) => el && el.hidden && !uniqueMainId.has(el.id));

      const preFlags = fl.preConditionFlags
        .map((el) => findFlagRef(el, flags))
        .filter((el) => el && el.hidden && !uniqueMainId.has(el.id));

      hiddenFlags.push(
        ...[...postFlags, ...preFlags].map((flag) => ({
          ...flag,
          addedUser: operatorData,
          addedDate: new Date(),
        })),
      );
    }

    const flagsReport = mainFlags.map((fl, index, clone) => {
      const pre = clone.filter((c) =>
        c.preConditionFlags.find(({ id }) => id === fl.id),
      );
      const post = clone.filter((c) =>
        c.postConditionFlags.find(({ id }) => id === fl.id),
      );

      return {
        ...findFlagRef(fl, flags),
        index,
        post,
        pre,
      };
    });

    const hiddenFlagsReport = hiddenFlags.map((fl, index) => {
      const pre = mainFlags.filter((c) =>
        c.preConditionFlags.find(({ id }) => id === fl.id),
      );
      const post = mainFlags.filter((c) =>
        c.postConditionFlags.find(({ id }) => id === fl.id),
      );

      return {
        ...findFlagRef(fl, flags),
        index,
        post,
        pre,
      };
    });

    // just include pre that are in Main level
    let mainFlagsWithMinorPre = mainFlags.map((flag, _, clone) => {
      const preOfOther = clone.filter((fl) =>
        fl.postConditionFlags.find((el) => el.id === flag.id),
      );

      return {
        ...flag,
        postConditionFlags: [],
        preConditionFlags: [...preOfOther, ...flag.preConditionFlags].filter(
          ({ id }) => clone.find((val) => val.id === id),
        ),
      };
    });

    // sort main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // get one flag
      // eslint-disable-next-line no-loop-func
      const targetFlag = mainFlagsWithMinorPre.find((fl) => {
        const preFlags = fl.preConditionFlags.map(({ id }) => id);
        // are flags rendered
        return isAllFlagsAddedToTerms(preFlags, finalTerms);
      });

      if (!targetFlag) break;

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };

      // check manual placement
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = [];
      for (const qa of relatedQuestionsForTermIndex) {
        const tempoIndex = termIndexFinderForGenerator(
          qa?.id,
          targetFlag.id,
          qa?.answer_id,
        );

        if (tempoIndex) tempTermIndex.push(tempoIndex);
      }
      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      console.log({
        targetFlag,
        relatedQuestionsForTermIndex,
        isManualExists,
        tempTermIndex,
        manualTermIndex,
      });

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }

      const conditions = findTermAndIndexOfPreOfFlag(targetFlag, finalTerms);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.max(...conditions.map((val) => val.termIndex));
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const cc = conditions
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        if (cc.length !== 0) {
          tempFlagIndex = Math.max(...cc);
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      } else {
        placement.termIndex = isManualExists ? manualTermIndex : 2;
      }

      console.log("main flags", {
        targetFlag,
        conditions,
        isManualExists,
        manualTermIndex,
        placement,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlagsWithMinorPre = mainFlagsWithMinorPre.filter(
        ({ id }) => id !== targetFlag.id,
      );
    }

    // sort hidden flags
    for (const targetFlag of hiddenFlags) {
      const conditions = findTermAndIndexOfPreOfHiddenFlagBaseOnMainFlag(
        targetFlag,
        finalTerms,
        flags,
      );

      const termIndex = Math.min(...conditions.map((val) => val.termIndex));
      const flagIndex = Math.min(
        ...conditions
          .filter((e) => e.termIndex === termIndex)
          .map((val) => val.flagIndex),
      );
      console.log({ termIndex, flagIndex });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: conditions.length === 0 ? 0 : termIndex - 1,
        colIndex: conditions.length === 0 ? 0 : flagIndex,
        terms: finalTerms,
      });
    }

    const allMainUniqueId = new Set(mainFlags.map(({ id }) => id));

    for (let index = 0; index < finalTerms.length; index++) {
      finalTerms[index] = finalTerms[index].map((flag, i) => {
        const isMainFlag = allMainUniqueId.has(flag.id);

        const flagRef = findFlagRef({ id: flag.id }, flags);
        const fReport = (
          uniqueMainId.has(flagRef.id) ? flagsReport : hiddenFlagsReport
        ).find(({ id }) => id === flag.id);

        if (!isMainFlag) {
          // find all post
          return {
            ...flagRef,
            report: {
              post: fReport?.post?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  allMainUniqueId.has(el.id),
              ),
              pre: fReport.pre?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  allMainUniqueId.has(el.id),
              ),
            },
            addedDate: new Date(),
            addedUser: operatorData,
            // autoGenerated: {},
            postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
              allMainUniqueId.has(id),
            ),
            preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
              allMainUniqueId.has(id),
            ),
          };
        }

        const relatedQuestions = tempFlagsPos
          .filter((el) => el.flagId === flagRef.id)
          .filter((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.id}` &&
                `${qa.answer_id}` === `${a.answer_id}`,
            );
          })
          .map((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.id}` &&
                `${qa.answer_id}` === `${a.answer_id}`,
            );
          })
          .filter((q) => q?.answer !== "" && q?.answer_id !== null);

        return {
          ...flag,
          addedDate: new Date(),
          addedUser: operatorData,
          postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
            allMainUniqueId.has(id),
          ),
          preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
            allMainUniqueId.has(id),
          ),
          report: {
            post: fReport.post?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                allMainUniqueId.has(el.id),
            ),
            pre: fReport.pre?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                allMainUniqueId.has(el.id),
            ),
          },
          autoGenerated: { ...flag.autoGenerated, relatedQuestions },
        };
      });
      newTerms[`term${index + 1}`].flags = finalTerms[index];
    }

    // sort other flags that have bug
    const conflictFlags = mainFlags
      .filter(({ id }) => !allMainUniqueId.has(id))
      .map((flag) => {
        const finalFlag = findFlagRef(flag, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);
        return {
          ...finalFlag,
          addedDate: new Date(),
          addedUser: operatorData,
          report: {
            post: fReport.post.filter((el) => allMainUniqueId.has(el.id)),
            pre: fReport.pre.filter((el) => allMainUniqueId.has(el.id)),
          },
          autoGenerated: { ...flag?.autoGenerated, conflict: true },
          postConditionFlags: finalFlag.postConditionFlags.filter(({ id }) =>
            allMainUniqueId.has(id),
          ),
          preConditionFlags: finalFlag.preConditionFlags.filter(({ id }) =>
            allMainUniqueId.has(id),
          ),
        };
      });
    newTerms[`term3`].flags = [...conflictFlags, ...newTerms[`term3`].flags];

    const shuffleTerms = shuffleSoloFlags(newTerms);

    // map termIndex to each
    for (let t = 0; t < 4; t++) {
      newTerms[`term${t + 1}`].flags = newTerms[`term${t + 1}`].flags.map(
        (fl) => ({
          ...fl,
          generatorTermIndex: t,
        }),
      );
    }

    const balancedTerms = balanceTerms(shuffleTerms);
    setIsRoadmapChanged(true);
    setTerms(balancedTerms);
    setFlags(getUnusedFlags(balancedTerms, flags));
    setIsRoadmapChanged(true);
    setPrevTermsClone(
      [].concat(
        ...[
          balancedTerms.term1.flags,
          balancedTerms.term2.flags,
          balancedTerms.term3.flags,
          balancedTerms.term4.flags,
        ].map((el) => el.map((f) => f.id)),
      ),
    );
    return balancedTerms;
  };

  const insertAnswersFlagsToRoadmap_NEW = () => {
    console.log("generator base on UUID for new");

    // check array exists
    if (!Array.isArray(questionAnswers)) return;

    console.log({ questionAnswers, questionToFlags });
    const newTerms = structuredClone(terms);
    let finalTerms = [[], [], [], []];
    let mainFlags = [];

    // set terms title
    const titleNames = getMonthNames();
    newTerms.term1.title = titleNames.term1;
    newTerms.term2.title = titleNames.term2;
    newTerms.term3.title = titleNames.term3;
    newTerms.term4.title = titleNames.term4;

    questionAnswers.forEach((qa) => {
      let answerFlags = [];
      let questionAnswer = null;

      // questionToFlags.forEach((el) => {
      //   if (
      //     qa.answer_id &&
      //     `${el.epollAnswerId}` === `${qa.answer_id}` &&
      //     `${el.epollQuestionId}` === `${qa.id}`
      //   ) {
      //     answerFlags = el.flags;
      //     questionAnswers.forEach((question) => {
      //       if (
      //         `${el.epollAnswerId}` === `${question.answer_id}` &&
      //         `${el.epollQuestionId}` === `${question.id}`
      //       ) {
      //         questionAnswer = question;
      //       }
      //     });
      //   }
      // });

      // answerFlags = tempFlagsPos
      //   .filter(
      //     (el) =>
      //       qa.answer_id &&
      //       `${el.answer_id}` === `${qa.answer_id}` &&
      //       `${el.id}` === `${qa.id}`
      //   )
      //   .map(({ flagId }) => flagId);

      const abc = tempFlagsPos.filter(
        (el) =>
          qa.answer_id &&
          `${el.answer_id}` === `${qa.answer_id}` &&
          `${el.id}` === `${qa.id}`,
      );
      answerFlags = abc.map(({ flagId }) => flagId);

      // questionAnswer = { ...qa, relatedQuestions: [qa] };
      questionAnswer = qa;

      const addedFlags = [];
      if (Array.isArray(answerFlags)) {
        flags.forEach((flag) => {
          answerFlags.forEach((id) => {
            if (`${flag.id}` === `${id}`) {
              addedFlags.push({
                ...flag,
                autoGenerated: questionAnswer,
                addedUser: operatorData,
                addedDate: new Date(),
              });
            }
          });
        });
      }
      console.log({ addedFlags, answerFlags, flags });

      const uniqueIds = [];
      const unique = addedFlags?.filter((element) => {
        if (!uniqueIds.includes(element.id)) {
          uniqueIds.push(element.id);
          return true;
        }
        return false;
      });
      mainFlags.push(...unique);
    });

    const uniqueMainId = new Set();
    mainFlags = mainFlags.filter(({ id }) => {
      if (uniqueMainId.has(id)) return false;
      uniqueMainId.add(id);
      return true;
    });
    mainFlags = ignoreFlagsFromGenerator(mainFlags);

    const flagsReport = mainFlags.map((fl, index, clone) => {
      const shouldBeBeforeMeIds = clone
        .map((e) => findFlagRef(e, flags))
        .filter((c) => c.postConditionFlags.find(({ id }) => id === fl.id))
        .map((e) => e.id);

      const shouldBeAfterMeIds = clone
        .map((e) => findFlagRef(e, flags))
        .filter((c) => c.preConditionFlags.find(({ id }) => id === fl.id))
        .map((e) => e.id);

      return {
        ...findFlagRef(fl, flags),
        index,
        shouldBeAfterMeIds: [
          ...shouldBeAfterMeIds,
          ...fl.postConditionFlags.map((e) => e.id),
        ],
        shouldBeBeforeMeIds: [
          ...fl.preConditionFlags.map((e) => e.id),
          ...shouldBeBeforeMeIds,
        ],
      };
    });
    console.log({ flagsReport, mainFlags });

    // sort main flags -> base on pre
    for (let index = 0; index < 1000; index++) {
      // eslint-disable-next-line no-loop-func
      const targetFlag = mainFlags
        .filter((e) => !e.hidden)
        // eslint-disable-next-line no-loop-func
        .find((fl) => {
          const flReport = flagsReport.find((e) => e.id === fl.id);
          const allPreNonHiddenFlagIds = flReport.shouldBeBeforeMeIds
            .filter((id) => !findFlagRef({ id }, flags).hidden)
            .filter((e) => uniqueMainId.has(e));

          // are flags rendered

          return isAllFlagsAddedToTerms(allPreNonHiddenFlagIds, finalTerms);
        });

      if (!targetFlag) break;

      const flReport = flagsReport.find(({ id }) => id === targetFlag.id);

      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };

      // check manual placement -----------------
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = relatedQuestionsForTermIndex
        .map((qa) =>
          termIndexFinderForGenerator(qa?.id, targetFlag.id, qa?.answer_id),
        )
        .filter((e) => e);

      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }
      // ------------ check manual placement

      const conditions = flReport.shouldBeBeforeMeIds
        .map((id) => findFlagPositionFromArrayTerms(id, finalTerms))
        .filter((e) => e);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        let tempTermIndex = Math.max(...conditions.map((val) => val.termIndex));
        let tempFlagIndex = 0;

        if (isManualExists) {
          tempTermIndex = Math.max(manualTermIndex, tempTermIndex);
        }

        const flagIndexArr = conditions
          .filter((c) => c.termIndex === tempTermIndex)
          .map((val) => val.flagIndex);

        if (flagIndexArr.length !== 0) {
          tempFlagIndex = Math.max(...flagIndexArr);
        }

        placement.flagIndex = tempFlagIndex;
        placement.termIndex = tempTermIndex;
      } else {
        placement.termIndex = isManualExists ? manualTermIndex : 2;
      }

      console.log(targetFlag.title, {
        targetFlag,
        flReport,
        relatedQuestionsForTermIndex,
        isManualExists,
        tempTermIndex,
        manualTermIndex,
        conditions,
        placement,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlags = mainFlags.filter(({ id }) => id !== targetFlag.id);
    }

    console.warn(
      "-------- sort hidden flags v10 --------",
      mainFlags.map((e) => ({
        ...e,
        report: flagsReport.find(({ id }) => id === e.id),
      })),
    );
    // sort hidden flags
    for (const targetFlag of mainFlags) {
      // break;
      // check conditions
      const placement = { termIndex: 2, flagIndex: 0 };
      const flReport = flagsReport.find((el) => el.id === targetFlag.id);

      // check manual placement -------------
      let manualTermIndex = termIndexFinderForGenerator(
        targetFlag.autoGenerated.id,
        targetFlag.id,
        targetFlag.autoGenerated.answer_id,
      );
      const relatedQuestionsForTermIndex = questionToFlags
        .filter((val) => val.flags.includes(targetFlag.id))
        .filter((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .map((a) => {
          return questionAnswers.find(
            (qa) =>
              `${qa.id}` === `${a.epollQuestionId}` &&
              `${qa.answer_id}` === `${a.epollAnswerId}`,
          );
        })
        .filter((q) => q?.answer !== "" && q?.answer_id !== null);

      const tempTermIndex = relatedQuestionsForTermIndex
        .map((qa) =>
          termIndexFinderForGenerator(qa?.id, targetFlag.id, qa?.answer_id),
        )
        .filter((e) => e);

      manualTermIndex = Math.min(...tempTermIndex, manualTermIndex);

      const isManualExists = manualTermIndex || manualTermIndex === 0;

      if (isManualExists) {
        manualTermIndex = manualTermIndex === 0 ? 2 : manualTermIndex - 1;
      }
      placement.termIndex = isManualExists ? manualTermIndex : 2;

      // ------------- check manual placement END -------------
      const conditions = flReport.shouldBeAfterMeIds
        .map((id) => findFlagPositionFromArrayTerms(id, finalTerms))
        .filter((e) => e);

      if (conditions.length !== 0) {
        // find min of termIndex from preConditions
        placement.termIndex = Math.min(
          ...conditions.map((val) => val.termIndex),
        );
        placement.flagIndex =
          Math.min(
            ...conditions
              .filter((c) => c.termIndex === placement.termIndex)
              .map((val) => val.flagIndex),
          ) - 1;
      }
      const conditionsSecond = flReport.shouldBeBeforeMeIds
        .map((id) => findFlagPositionFromArrayTerms(id, finalTerms))
        .filter((e) => e);

      if (conditionsSecond.length !== 0) {
        // find min of termIndex from preConditions
        const secondTermIndex = Math.max(
          ...conditionsSecond.map((val) => val.termIndex),
        );
        const secondFlagIndex = Math.max(
          ...conditionsSecond
            .filter((c) => c.termIndex === placement.termIndex)
            .map((val) => val.flagIndex),
        );
      }

      console.log("hidden flag", targetFlag.title, {
        targetFlag,
        conditions,
        isManualExists,
        manualTermIndex,
        placement,
        relatedQuestionsForTermIndex,
        flReport,
      });

      // insert flag into terms
      finalTerms = insertFlagIntoTerm({
        flag: targetFlag,
        termIndex: placement.termIndex,
        colIndex: placement.flagIndex,
        terms: finalTerms,
      });

      // remove from mainFlagsWithMinorPostPre
      mainFlags = mainFlags.filter(({ id }) => id !== targetFlag.id);
    }

    for (let index = 0; index < finalTerms.length; index++) {
      finalTerms[index] = finalTerms[index].map((flag, i) => {
        const isMainFlag = uniqueMainId.has(flag.id);

        const flagRef = findFlagRef({ id: flag.id }, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);

        if (!isMainFlag) {
          // find all post
          return {
            ...flagRef,
            report: {
              post: fReport?.post?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  uniqueMainId.has(el.id),
              ),
              pre: fReport.pre?.filter(
                (el) =>
                  el?.autoGenerated?.answer?.trim() !== "" &&
                  el?.autoGenerated?.answer_id !== null &&
                  uniqueMainId.has(el.id),
              ),
            },
            postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
              uniqueMainId.has(id),
            ),
            preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
              uniqueMainId.has(id),
            ),
            addedDate: new Date(),
            addedUser: operatorData,
            // autoGenerated: {},
          };
        }

        const relatedQuestions = tempFlagsPos
          .filter((el) => el.flagId === flagRef.id)
          .filter((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.id}` &&
                `${qa.answer_id}` === `${a.answer_id}`,
            );
          })
          .map((a) => {
            return questionAnswers.find(
              (qa) =>
                `${qa.id}` === `${a.id}` &&
                `${qa.answer_id}` === `${a.answer_id}`,
            );
          })
          .filter((q) => q?.answer !== "" && q?.answer_id !== null);

        return {
          ...flag,
          addedDate: new Date(),
          addedUser: operatorData,
          postConditionFlags: flagRef.postConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          preConditionFlags: flagRef.preConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          report: {
            post: fReport.post?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                uniqueMainId.has(el.id),
            ),
            pre: fReport.pre?.filter(
              (el) =>
                el?.autoGenerated?.answer?.trim() !== "" &&
                el?.autoGenerated?.answer_id !== null &&
                uniqueMainId.has(el.id),
            ),
          },
          autoGenerated: { ...flag.autoGenerated, relatedQuestions },
        };
      });
      newTerms[`term${index + 1}`].flags = finalTerms[index];
    }

    // sort other flags that have bug
    const conflictFlags = mainFlags
      .filter(({ id }) => !uniqueMainId.has(id))
      .map((flag) => {
        const finalFlag = findFlagRef(flag, flags);
        const fReport = flagsReport.find(({ id }) => id === flag.id);
        return {
          ...finalFlag,
          addedDate: new Date(),
          addedUser: operatorData,
          report: {
            post: fReport.post.filter((e) => uniqueMainId.has(e.id)),
            pre: fReport.pre.filter((e) => uniqueMainId.has(e.id)),
          },
          autoGenerated: { ...flag?.autoGenerated, conflict: true },
          postConditionFlags: finalFlag.postConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
          preConditionFlags: finalFlag.preConditionFlags.filter(({ id }) =>
            uniqueMainId.has(id),
          ),
        };
      });
    newTerms[`term3`].flags = [...conflictFlags, ...newTerms[`term3`].flags];

    const shuffleTerms = shuffleSoloFlags(newTerms);
    const balancedTerms = balanceTerms(shuffleTerms);
    for (let t = 0; t < 4; t++) {
      balancedTerms[`term${t + 1}`].flags = balancedTerms[`term${t + 1}`].flags.map(
        (fl) => ({ ...fl, generatorTermIndex: t }),
      );
    }
    // const balancedTerms = newTerms;
    setIsRoadmapChanged(true);
    setTerms(balancedTerms);
    setFlags(getUnusedFlags(balancedTerms, flags));

    setIsRoadmapChanged(true);

    setPrevTermsClone(
      [].concat(
        ...[
          balancedTerms.term1.flags,
          balancedTerms.term2.flags,
          balancedTerms.term3.flags,
          balancedTerms.term4.flags,
        ].map((el) => el.map((f) => f.id)),
      ),
    );
    return balancedTerms;
  };

  const getMonthNames = () => {
    const currentDate = moment().locale("fa");

    if (+currentDate.date() >= 20) currentDate.add(1, "jMonth");

    return {
      term1: `${currentDate.format("jMMMM")} و ${currentDate
        .add(1, "jMonth")
        .format("jMMMM")}`,
      term2: `${currentDate.add(1, "jMonth").format("jMMMM")} و ${currentDate
        .add(1, "jMonth")
        .format("jMMMM")}`,
      term3: `${currentDate.add(1, "jMonth").format("jMMMM")} و ${currentDate
        .add(1, "jMonth")
        .format("jMMMM")}`,
      term4: `${currentDate.add(1, "jMonth").format("jMMMM")} و ${currentDate
        .add(1, "jMonth")
        .format("jMMMM")}`,
    };
  };

  const flagConflictsList = useCallback(
    (flagId) => {
      const target =
        (flagsConflict[productCode] ?? []).find((e) => e.flagId === flagId)
          ?.conflictWith ?? [];
      const other = (flagsConflict[productCode] ?? [])
        .filter((e) => e.conflictWith.includes(flagId))
        .map((e) => e.flagId);

      return Array.from(new Set([...other, ...target]));
    },
    [productCode],
  );

  const getFlagExistingConflict = (flagId) => {
    const list = flagConflictsList(flagId);

    return list
      .filter((e) => allRoadmapFlags.includes(e))
      .map((id) => ({ ...(findFlagRef({ id }, flagsRef?.current) ?? {}) }))
      .filter((e) => e?.id);
  };

  const conflictExistsInRoadmap = useMemo(() => {
    return allRoadmapFlags.some((flagId) =>
      flagConflictsList(flagId).some((e) => allRoadmapFlags.includes(e)),
    );
  }, [allRoadmapFlags, flagConflictsList]);

  const removeUsedFlags = (roadmap) => {
    if (flagsRef.current && terms) {
      let allUserFlags = Object.keys(terms).map((key) => {
        return terms[key].flags;
      });
      if (roadmap) {
        allUserFlags = Object.keys(roadmap).map((key) => {
          return roadmap[key].flags;
        });
      }
      const editedFlags = Array.from(flagsRef.current)
        .map((flag) => {
          let userFlagIsUsed = false;
          allUserFlags.forEach((flagArr) => {
            Array.from(flagArr).forEach((userFlag) => {
              if (userFlag && flag) {
                if (userFlag.id === flag.id) {
                  userFlagIsUsed = true;
                }
              }
            });
          });
          return userFlagIsUsed ? null : flag;
        })
        .filter((el) => el !== null);
      setFlags(editedFlags);
    }
  };

  const removeUsedSkills = () => {
    if (skillsRef.current && skillTerms) {
      const allUserSkills = Object.keys(skillTerms).map((key) => {
        return skillTerms[key].skills;
      });

      const editedSkills = Array.from(skillsRef.current)
        .map((skill) => {
          let userSkillIsUsed = false;
          allUserSkills.forEach((SkillArr) => {
            Array.from(SkillArr).forEach((userSkill) => {
              if (userSkill && skill) {
                if (userSkill.id === skill.id) {
                  userSkillIsUsed = true;
                }
              }
            });
          });
          return userSkillIsUsed ? null : skill;
        })
        .filter((el) => el !== null);
      setSkills(editedSkills);
      console.log("here02");
    }
  };

  const onSelectType = (tempType) => {
    api.get(`/roadmaptypes/${tempType.id}`).then((res) => {
      const type = res.data;
      setTerms(type.flagsRoadmap);
      setSkillTerms(defaultSkillsTermsValue);
      setSkills(JSON.parse(JSON.stringify(skillsRef.current)));
      console.log("here03");
      removeUsedFlags(type.flagsRoadmap);
      setIsRoadmapChanged(true);
      setSelectedType(type.id);
    });
  };

  const onReset = () => {
    setTerms(defaultTermsValue);
    setSkillTerms(defaultSkillsTermsValue);
    setFlags(JSON.parse(JSON.stringify(flagsRef.current)));
    setSkills(JSON.parse(JSON.stringify(skillsRef.current)));
    console.log("here04");
    setIsRoadmapChanged(true);
  };

  const removeHtmlTags = (str) => {
    if (str === null || str === "") return false;
    else str = str.toString();
    return str.replace(/(<([^>]+)>)/gi, "");
  };

  const removeQuestionNumber = useCallback(
    (str) => str.replace(/^\d+(\.\d+)*(_\d+)?\s*:\s*/, "").trim(),
    [],
  );

  const exportedTypesFromAnswers = useMemo(() => {
    return autoTypes
      .map((cond) => {
        const findQuestion = questionAnswers.find(
          (e) =>
            e.id === cond.questionId &&
            e?.answer &&
            (cond.answerId === "ACCEPT_ANY"
              ? true
              : cond.answerId === e.answer_id),
        );

        if (!findQuestion) return false;

        return {
          question: removeQuestionNumber(findQuestion.question),
          value: removeQuestionNumber(
            cond.valueToInsert
              ? typeof cond.valueToInsert === "string"
                ? cond.valueToInsert
                : cond.valueToInsert(findQuestion?.answer)
              : findQuestion?.answer,
          ),
        };
      })
      .filter((e) => e);

    //
  }, [questionAnswers]);

  const exportedAdjectiveFromAnswers_old = useMemo(() => {
    console.log({ questionAnswers, autoAdjectives });
    const finalResponse = autoAdjectives
      .map((cond) => {
        const findQuestion = questionAnswers.find(
          (e) =>
            e.id == cond.questionId &&
            e?.answer &&
            (cond.answerId === "ACCEPT_ANY"
              ? true
              : cond.answerId === e.answer_id),
        );

        if (!findQuestion) return false;

        return {
          ...cond,
          findQuestion,
          finalValue: removeQuestionNumber(
            cond.valueToInsert
              ? typeof cond.valueToInsert === "string"
                ? cond.valueToInsert
                : cond.valueToInsert(findQuestion?.answer)
              : findQuestion?.answer,
          ),
        };
      })
      .filter((e) => e);

    return Array.from(new Set(finalResponse.map((e) => e.finalValue)));
  }, [questionAnswers, autoAdjectives, removeQuestionNumber]);

  const exportedAdjectiveFromAnswers = useMemo(() => {
    const matched = autoAdjectives
      .map((cond) => {
        const findQuestion = !cond.questionId
          ? questionAnswers.find((q) => q.id == cond.answerId && q?.answer)
          : questionAnswers.find(
              (q) =>
                q.id == cond.questionId &&
                q?.answer &&
                (cond.answerId === "ACCEPT_ANY"
                  ? true
                  : q.answer_id == cond.answerId),
            );

        if (!findQuestion) return false;

        const resolvedValue = cond.valueToInsert
          ? typeof cond.valueToInsert === "string"
            ? cond.valueToInsert
            : cond.valueToInsert(findQuestion?.answer)
          : findQuestion?.answer;

        return removeQuestionNumber(resolvedValue);
      })
      .filter((v) => v);

    return Array.from(new Set(matched));
  }, [questionAnswers, autoAdjectives]);

  const getAutoNotes = useCallback(
    async () =>
      await api
        .get("/auto-note")
        .then((res) => {
          setAutoNote(res.data);
        })
        .catch(() => message.error("خطا در دریافت نظر کارشناس اتومات")),
    [],
  );

  const exportedAutoNotes = useMemo(() => {
    const finalResponse = [];
    const notes = autoNote
      .filter(
        (e) =>
          e.priority !== 0 &&
          e.typeTags.every((el) => exportedAdjectiveFromAnswers.includes(el)),
      )
      .sort((a, b) => a.priority - b.priority);

    finalResponse.push(...notes.filter((e) => e.priority === 1));

    if (finalResponse.length < 3) {
      finalResponse.push(
        ...notes
          .filter((e) => e.priority !== 1)
          .slice(0, 3 - finalResponse.length),
      );
    }

    return finalResponse;
  }, [exportedAdjectiveFromAnswers, autoNote]);

  const buildAutoNoteForUser = () =>
    buildAutoNote({
      productCode,
      isRenewal: !!prevRoadmapKey,
      username,
      values: exportedAutoNotes?.map((e) => e.value) ?? [],
    });

  const handleAutoNotFromTypeAdjectives = () => {
    setUserNote(buildAutoNoteForUser());
  };

  useEffect(() => {
    if (!RoadmapHasNoteFromBefore && exportedAutoNotes.length > 0) {
      handleAutoNotFromTypeAdjectives();
    }
  }, [exportedAutoNotes, RoadmapHasNoteFromBefore, productCode]);

  const ensureUserNoteOnSave = () => {
    if (RoadmapHasNoteFromBefore || !roadmapId) return;
    const note = normalizeUserNote(
      userNote && removeHtmlTags(userNote).trim() !== ""
        ? userNote
        : buildAutoNoteForUser(),
    );
    if (!note || removeHtmlTags(note).trim() === "") return;
    api
      .post("/roadmaps/usernote", { roadmapId, note, onlyIfEmpty: true })
      .then(() => {
        setUserNote(note);
        setRoadmapHasNoteFromBefore(true);
      })
      .catch(() => {});
  };

  const markUserNoteSaved = () => {
    setRoadmapHasNoteFromBefore(true);
  };

  const balanceTerms = (tempTerms) => {
    let newTerms = [
      [...tempTerms.term1.flags],
      [...tempTerms.term2.flags],
      [...tempTerms.term3.flags],
      [...tempTerms.term4.flags],
    ];

    // get total flags count
    const totalFlagsCount = [
      ...tempTerms.term1.flags,
      ...tempTerms.term2.flags,
      ...tempTerms.term3.flags,
      ...tempTerms.term4.flags,
    ].filter((v) => !v?.hidden).length;

    let usedFlagsCount = 0;

    for (let index = 0; index < 4; index++) {
      if (index === 3) continue;

      const newFlagsCount = Math.ceil(
        (totalFlagsCount - usedFlagsCount) / (4 - index),
      );

      usedFlagsCount += newFlagsCount;

      const differenceFlagCount =
        newFlagsCount - newTerms[index].filter((v) => !v?.hidden).length;

      // need to be add from next term
      if (differenceFlagCount > 0) {
        // how many flags we need?
        const deffC = Math.min(
          newTerms[index + 1].filter((v) => !v?.hidden).length,
          differenceFlagCount,
        );

        // get flags
        let movingFlags = newTerms[index + 1].filter((v) => !v?.hidden);

        movingFlags = movingFlags.slice(0, deffC);

        if (movingFlags.length === 0) continue;

        let cc = -1;
        for (const aaa in newTerms[index + 1]) {
          const aa = newTerms[index + 1][+aaa];
          if (aa.id === movingFlags[movingFlags.length - 1]?.id) {
            cc = +aaa;
            break;
          }
        }

        movingFlags = newTerms[index + 1]
          .slice(0, cc + 1)
          .map((el) => ({ ...el, forcedToMoved: true }));

        // remove flags from next term
        newTerms[index + 1] = newTerms[index + 1].filter(
          (el) => !movingFlags.find((obj) => obj.id === el.id),
        );

        // sign to current term
        newTerms[index] = [
          ...newTerms[index],
          ...movingFlags.map((fl) => ({ ...fl, balanceTermIndex: index })),
        ];

        // need to be move to next term
      } else if (differenceFlagCount < 0) {
        const deff = Math.min(
          Math.abs(differenceFlagCount),
          newTerms[index].filter((v) => !v?.hidden).length,
        );

        // get flags
        let movingFlags = [...newTerms[index]]
          .reverse()
          .filter((v) => !v?.hidden);

        movingFlags = movingFlags.slice(0, deff);

        if (movingFlags.length === 0) continue;

        let cc = -1;
        for (const aaa in newTerms[index]) {
          const aa = [...newTerms[index]].reverse()[+aaa];
          if (aa.id === movingFlags[movingFlags.length - 1]?.id) {
            cc = +aaa;
            break;
          }
        }

        movingFlags = [...newTerms[index]]
          .reverse()
          .slice(0, cc + 1)
          .map((el) => ({ ...el, forcedToMoved: true }));

        // remove flags from next term
        newTerms[index] = newTerms[index].filter(
          (el) => !movingFlags.find((obj) => obj.id === el.id),
        );

        // sign to next term
        newTerms[index + 1] = [
          ...movingFlags
            .reverse()
            .map((fl) => ({ ...fl, balanceTermIndex: index + 1 })),
          ...newTerms[index + 1],
        ];
      }
    }
    return {
      term1: { ...tempTerms.term1, flags: newTerms[0] },
      term2: { ...tempTerms.term2, flags: newTerms[1] },
      term3: { ...tempTerms.term3, flags: newTerms[2] },
      term4: { ...tempTerms.term4, flags: newTerms[3] },
    };
  };

  const balanceButtonHandler = () => {
    if (!terms) return;

    try {
      setTerms((prev) => balanceTerms(prev));
      message.success("تعادل با موفقیت رعایت شد");
    } catch (error) {
      message.error("خطا در ایجاد تعادل");
    }
  };

  const getFlagIgnoreTags = () => {
    api
      .get(`/question-ignore-tag/${formId}`)
      .then(({ data }) => setIgnoreTags(data))
      .catch(() => message.error("خطا در دریافت تگ های متصل"));
  };

  const getIgnoreFlagsBaseOnTag = () => {
    const availableTags = new Set();
    const shouldRemoveFlagsId = new Set();

    // get available tags
    for (const qa of questionAnswers) {
      ignoreTag
        .filter((tag) =>
          qa.answer_id
            ? `${tag.answer_id}` === `${qa.id}` &&
              `${tag.question_id}` === `${qa.answer_id}`
            : tag.answer_id === null && `${tag.question_id}` === `${qa.id}`,
        )
        .forEach(({ tag }) => availableTags.add(tag));
    }

    // get which flags should remove
    for (const tag of availableTags) {
      flagsClone
        .filter((fl) => fl.flagTag.indexOf(tag) !== -1)
        .forEach(({ id }) => shouldRemoveFlagsId.add(id));
    }

    return {
      availableTags: Array.from(availableTags),
      shouldRemoveFlagsId: Array.from(shouldRemoveFlagsId),
    };
  };

  const getIgnoreFlagsSingle = () => {
    const ignoredFlagsUniqueId = new Set();

    ignoreFlags
      .filter((cond) =>
        questionAnswers.find((qa) =>
          cond.answer_id
            ? `${qa.answer_id}` === `${cond.answer_id}` &&
              `${qa.id}` === `${cond.question_id}`
            : `${qa.id}` === `${cond.question_id}`,
        ),
      )
      .forEach((el) => ignoredFlagsUniqueId.add(el?.bom_item?.id));

    return Array.from(ignoredFlagsUniqueId);
  };

  const checkOverFlowFlag = (flagId) => {
    return overLoadFLags.includes(flagId);
  };

  const checkIsDeletedFlag = (flagId) => {
    return deletedFlags.find((e) => e.id === flagId);
  };

  const getCurrentTermFlags = () => {
    if (Array.isArray(terms)) {
      return [].concat(...terms.map((term) => term.flags));
    }

    if (
      typeof terms === "object" &&
      terms !== null &&
      Object.keys(terms).length === 4
    ) {
      return [].concat(
        ...Object.keys(terms).map((objKey) => terms[objKey]?.flags),
      );
    }

    return [];
  };

  const checkHistory = (shouldSet = true) => {
    const flagsOfCurrent = getCurrentTermFlags();

    // get flags that added
    const addedFlags = flagsOfCurrent
      .filter((fl) => !prevTermsClone?.find((el) => el === fl.id))
      .map((el) => el.id);

    // get flags that removed
    const removedFlags = prevTermsClone?.filter(
      (fl) => !flagsOfCurrent.find((el) => el.id === fl),
    );

    const newFlagsHistory = { ...flagsHistory };

    if (Array.isArray(addedFlags)) {
      for (const addFl of addedFlags) {
        if (newFlagsHistory[+addFl]) {
          newFlagsHistory[+addFl] = [
            ...newFlagsHistory[+addFl],
            {
              operate: "add",
              user: operatorData,
              date: new Date(),
            },
          ];
        } else {
          newFlagsHistory[+addFl] = [
            {
              operate: "add",
              user: operatorData,
              date: new Date(),
            },
          ];
        }
      }
    }

    if (Array.isArray(removedFlags)) {
      for (const rmFl of removedFlags) {
        if (newFlagsHistory[+rmFl]) {
          newFlagsHistory[+rmFl] = [
            ...newFlagsHistory[+rmFl],
            {
              operate: "remove",
              user: operatorData,
              date: new Date(),
            },
          ];
        } else {
          newFlagsHistory[+rmFl] = [
            {
              operate: "remove",
              user: operatorData,
              date: new Date(),
            },
          ];
        }
      }
    }

    if (shouldSet) {
      setFlagsHistory(newFlagsHistory);
    }

    return { removedFlags, addedFlags, newFlagsHistory };
  };

  const changeShowImportant = (checked) => {
    const scrollTop = document.getElementById("questions-container").scrollTop;
    const questionLabels = document.querySelectorAll(".break-question");

    let labelSelected = questionLabels[0]?.id;
    for (const label of questionLabels) {
      if (scrollTop >= label.offsetTop - 50) {
        labelSelected = label.id;
      }
    }

    setQuestionLabelToScroll(labelSelected);
    setShowImportantOnly(checked);
  };

  useEffect(() => {
    setTimeout(() => {
      const labelTop = document.getElementById(
        questionLabelToScroll,
      )?.offsetTop;
      document
        .getElementById("questions-container")
        .scrollTo({ top: labelTop, behavior: "smooth" });
    }, 300);
  }, [showImportantOnly]);

  useEffect(() => {
    if (formDto?.form_id) {
      getFlagIgnoreTags(formDto?.form_id);
    }
  }, [formDto]);

  useEffect(() => {
    loadUserFromPanel();
    loadUserEpoll();

    // loadData();
    // if (!epollId) {
    //   loadUserFromPanel();
    // } else {
    //   loadUserEpoll();
    // }
  }, []);

  useEffect(() => {
    if (!questionAnswers) return;

    const gender = questionAnswers?.find(
      (qa) =>
        qa?.question?.search("جنسیت") && qa?.question?.search("جنسیت") !== -1,
    );

    const age = questionAnswers?.find(
      (qa) =>
        qa?.question?.trim().search("سن") &&
        qa?.question?.trim().search("سن") !== -1,
    );

    if (age) setTypeData((prev) => ({ ...prev, age: age?.answer }));
    if (gender) setTypeData((prev) => ({ ...prev, gender: gender?.answer }));
  }, [questionAnswers]);

  useEffect(() => {
    window.onbeforeunload = function () {
      return true;
    };

    return () => {
      window.onbeforeunload = null;
    };
  }, []);

  useEffect(() => {
    if (isRoadmapChanged) {
      window.onbeforeunload = function (e) {
        return true;
      };
    } else {
      window.onbeforeunload = null;
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [isRoadmapChanged]);

  useEffect(() => {
    if (formDto && answers) {
      const questionAnswersObj = EpollParser(formDto, answers);
      setQuestionAnswers(questionAnswersObj);
    }
  }, [formDto, answers]);

  useEffect(() => {
    removeUsedFlags();
    removeUsedSkills();
  }, [isFetchedData]);

  return (
    <div>
      <RoadmapControls
        isRenewal={!!prevRoadmapKey}
        onRemoveDuplicateImportantFlags={removeDuplicateImportantFlags}
        getImportantAreasFn={getImportantAreasFn}
        importantAreas={importantAreas}
        exportedAutoNotes={exportedAutoNotes}
        findTermAndIndexOfPreOfHiddenFlagBaseOnMainFlag={
          findTermAndIndexOfPreOfHiddenFlagBaseOnMainFlag
        }
        resetFlagsList={(newTerm) =>
          setFlags(getUnusedFlags(newTerm, flagsClone))
        }
        findFlag={(id) => findFlagRef({ id }, flagsRef.current)}
        allRoadmapFlags={allRoadmapFlags}
        flagsPosBeforeDelete={flagsPosBeforeDelete}
        conflictExistsInRoadmap={conflictExistsInRoadmap}
        exportedAdjectiveFromAnswers={exportedAdjectiveFromAnswers}
        exportedTypesFromAnswers={exportedTypesFromAnswers}
        productCode={productCode}
        prevRoadmapKey={prevRoadmapKey}
        prevNoteForUser={prevNoteForUser}
        checkHistory={checkHistory}
        username={username}
        deletedFlags={deletedFlags}
        setDeletedFlags={setDeletedFlags}
        limitRoadmapHandler={limitRoadmapHandler}
        roadmapStatus={roadmapStatus}
        setRoadmapStatus={setRoadmapStatus}
        autoPublish={autoPublish}
        setAutoPublish={setAutoPublish}
        balanceButtonHandler={balanceButtonHandler}
        userTypeData={typeData}
        editigMode={editigMode}
        epollRecordId={epollRecordId}
        globalSearch={globalSearch}
        insertAnswersFlagsToRoadmap={insertAnswersFlagsToRoadmap}
        unGeneratorRemoveFlags={unGeneratorRemoveFlags}
        isPublished={isPublished}
        isRoadmapChanged={isRoadmapChanged}
        note={note}
        onReset={onReset}
        onSelectType={onSelectType}
        selectedType={selectedType}
        setSelectedType={setSelectedType}
        roadmap={terms}
        roadmapId={roadmapId}
        roadmapKey={key}
        loadUserTerms={loadUserTerms}
        setEditingMode={setEditingMode}
        setGlobalSearch={setGlobalSearch}
        setIsPublished={setIsPublished}
        setIsRoadmapChanged={setIsRoadmapChanged}
        setNote={setNote}
        setUserNote={setUserNote}
        userNote={userNote}
        userNoteVoiceUrl={userNoteVoiceUrl}
        setUserNoteVoiceUrl={setUserNoteVoiceUrl}
        ensureUserNoteOnSave={ensureUserNoteOnSave}
        markUserNoteSaved={markUserNoteSaved}
        hasSavedNote={RoadmapHasNoteFromBefore}
        skillTerms={skillTerms}
        terms={terms}
        setTerms={setTerms}
        ignoreFlagsFromGenerator={ignoreFlagsFromGenerator}
        userData={userData}
        transparentMode={transparentMode}
        setTransparentMode={setTransparentMode}
      />
      <div className={styles.UserRoadmap}>
        {editigMode === "actions" && (
          <ActionsRoadmap
            checkIsDeletedFlag={checkIsDeletedFlag}
            ignoreImportanceArr={ignoreImportanceArr}
            toggleImportance={toggleImportance}
            rePositionPrevHiddenFlags={rePositionPrevHiddenFlags}
            resortPrevFlag={resortPrevFlag}
            getFlagImportance={getFlagImportance}
            getFlagExistingConflict={getFlagExistingConflict}
            balanceTerms={balanceTerms}
            relatedFlagsList={Array.from(
              new Set(tempFlagsPos.map((fl) => fl.flagId)),
            )}
            segment={segment}
            setSegment={setSegment}
            ignoreFlagsFromGenerator={ignoreFlagsFromGenerator}
            operatorData={operatorData}
            flagsHistory={flagsHistory}
            transparentMode={transparentMode}
            checkHistory={checkHistory}
            checkOverFlowFlag={checkOverFlowFlag}
            mapPreAndPostConditionFlags={mapPreAndPostConditionFlags}
            getIgnoreFlagsBaseOnTag={getIgnoreFlagsBaseOnTag}
            getIgnoreFlagsSingle={getIgnoreFlagsSingle}
            globalSearch={globalSearch}
            terms={terms}
            termIndexFinder={termIndexFinder}
            setTerms={setTerms}
            isRoadmapChanged={isRoadmapChanged}
            setIsRoadmapChanged={setIsRoadmapChanged}
            roadmapId={roadmapId}
            flags={flags}
            flagsRef={flagsRef.current}
            setFlags={setFlags}
            allRoadmapFlags={allRoadmapFlags}
            otherRoadmapsFlagIds={otherRoadmapsFlagIds}
          />
        )}
        {editigMode === "skills" && (
          <SkillsRoadmap
            globalSearch={globalSearch}
            terms={skillTerms}
            setTerms={setSkillTerms}
            isRoadmapChanged={isRoadmapChanged}
            setIsRoadmapChanged={setIsRoadmapChanged}
            roadmapId={roadmapId}
            skills={skills}
            flagsRef={flagsRef.current}
            skillsRef={skillsRef.current}
            setSkills={setSkills}
          />
        )}

        <div>
          {epollId && roadmapId && (
            <div
              style={{
                padding: "1rem",
                paddingTop: "0.2rem",
                paddingRight: "0.5rem",
                backgroundColor: "#F2F2F2",
                borderRadius: "1rem 1rem 0 0",
                transform: "translateY(0.1rem)",
              }}
            >
              <h1 className={styles.QandATitle}>سوال‌ها و جواب‌ها</h1>
              <div>
                <Input
                  onChange={(e) => {
                    if (e.target.value === "") {
                      setSearch("");
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      setSearch(e.target.value);
                    }
                  }}
                  placeholder="پس از وارد کردن مقدار جستجو، دکمه Enter را بزنید."
                />
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "0.5rem",
                  }}
                >
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <WarningIcon
                      style={{ marginLeft: "0.2rem", color: "#858585" }}
                      fontSize="small"
                    />
                    نمایش سوالات مهم
                  </div>
                  <Switch
                    onChange={(checked) => changeShowImportant(checked)}
                    defaultChecked={showImportantOnly}
                  />
                </div>
              </div>
            </div>
          )}

          <div id="questions-container" className={styles.QandA}>
            {epollId && roadmapId ? (
              <EpollAnswers
                showImportantOnly={showImportantOnly}
                isValidUUID={isValidUUID}
                ignoreTag={ignoreTag}
                checkFlagExistsInRoadmap={(flId) =>
                  allRoadmapFlags.find((e) => e == flId)
                }
                flagIgnoredByGenerator={flagIgnoredByGenerator}
                formId={formId}
                starQuestions={starQuestions}
                setStarQuestions={setStarQuestions}
                search={search}
                setSearch={setSearch}
                questionToTypes={questionToTypes}
                questionToFlags={isValidUUID ? tempFlagsPos : questionToFlags}
                roadmapId={roadmapId}
                answersNote={answersNote}
                allFlags={flagsClone}
                setAnswersNote={setAnswersNote}
                answersHighlight={answersHighlight ? answersHighlight : {}}
                answersChecked={answersChecked ? answersChecked : {}}
                insertQuestionFlagsToRoadmap={insertQuestionFlagsToRoadmap}
                unBookmarkRemoveFlags={unBookmarkRemoveFlags}
                questionAnswers={questionAnswers}
                answerId={answers ? answers.id : null}
                flagsRef={flagsRef.current}
                userData={userData}
              />
            ) : (
              <Loading />
            )}
          </div>
        </div>
      </div>
      <AppUsageTracker />
    </div>
  );
};

export const findFlagRef = (flag, flagsRef) => {
  let flagRef = null;
  if (Array.isArray(flagsRef)) {
    for (let index = 0; index < flagsRef.length; index++) {
      const el = flagsRef[index];
      if (el.id === flag.id) {
        flagRef = el;
        index = flagsRef.length;
        break;
      }
    }
  }
  return flagRef;
};
const mapStateToProps = (state) => {
  return {
    operatorData: state.userData,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    ClearLoading: () => dispatch(actions.ClearLoading()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(memo(UserRoadmapBeta));
